require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.string.repeat");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("styled-components"), require("@tinacms/styles"), require("react"), require("react-dismissible"), require("react-color"), require("color-string"), require("react-dropzone"), require("@tinacms/icons"), require("prosemirror-view"), require("prosemirror-state"), require("prosemirror-dropcursor"), require("prosemirror-gapcursor"), require("prosemirror-history"), require("prosemirror-keymap"), require("prosemirror-tables"), require("prosemirror-inputrules"), require("prosemirror-commands"), require("prosemirror-model"), require("react-dom"), require("prosemirror-utils"), require("prosemirror-schema-list"), require("prosemirror-transform"), require("lodash.debounce")) : "function" == typeof define && define.amd ? define(["exports", "styled-components", "@tinacms/styles", "react", "react-dismissible", "react-color", "color-string", "react-dropzone", "@tinacms/icons", "prosemirror-view", "prosemirror-state", "prosemirror-dropcursor", "prosemirror-gapcursor", "prosemirror-history", "prosemirror-keymap", "prosemirror-tables", "prosemirror-inputrules", "prosemirror-commands", "prosemirror-model", "react-dom", "prosemirror-utils", "prosemirror-schema-list", "prosemirror-transform", "lodash.debounce"], e) : e((n = n || self)["@tinacms/fields"] = {}, n.styled, n.styles, n.React, n.reactDismissible, n.reactColor, n.colorString, n.reactDropzone, n.icons, n.prosemirrorView, n.prosemirrorState, n.prosemirrorDropcursor, n.prosemirrorGapcursor, n.prosemirrorHistory, n.prosemirrorKeymap, n.TableCommands, n.prosemirrorInputrules, n.prosemirrorCommands, n.prosemirrorModel, n.ReactDOM, n.prosemirrorUtils, n.prosemirrorSchemaList, n.prosemirrorTransform, n.debounce);
}(this, function (n, g, O, R, f, e, r, u, m, h, N, i, a, s, l, b, d, v, k, w, x, o, c, q) {
  "use strict";

  var t = "default" in g ? g["default"] : g,
      $ = "default" in R ? R["default"] : R,
      p = "default" in w ? w["default"] : w;
  q = q && q.hasOwnProperty("default") ? q["default"] : q;

  var _y = function y(n, e) {
    return (_y = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (n, e) {
      n.__proto__ = e;
    } || function (n, e) {
      for (var t in e) {
        e.hasOwnProperty(t) && (n[t] = e[t]);
      }
    })(n, e);
  };

  function C(n, e) {
    function t() {
      this.constructor = n;
    }

    _y(n, e), n.prototype = null === e ? Object.create(e) : (t.prototype = e.prototype, new t());
  }

  var _H = function H() {
    return (_H = Object.assign || function (n) {
      for (var e, t = 1, r = arguments.length; t < r; t++) {
        for (var o in e = arguments[t]) {
          Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
        }
      }

      return n;
    }).apply(this, arguments);
  };

  function _(n, e) {
    var t = {};

    for (var r in n) {
      Object.prototype.hasOwnProperty.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
    }

    if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (r = Object.getOwnPropertySymbols(n); o < r.length; o++) {
        e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[o]) && (t[r[o]] = n[r[o]]);
      }
    }

    return t;
  }

  function M() {
    for (var n = 0, e = 0, t = arguments.length; e < t; e++) {
      n += arguments[e].length;
    }

    var r = Array(n),
        o = 0;

    for (e = 0; e < t; e++) {
      for (var i = arguments[e], a = 0, s = i.length; a < s; a++, o++) {
        r[o] = i[a];
      }
    }

    return r;
  }

  function E(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }

  var z,
      A,
      S,
      T,
      L,
      I,
      F,
      D,
      B = g.css(A = A || E(["\n  padding: ", ";\n  border-radius: ", ";\n  background: ", ";\n  font-size: ", ";\n  line-height: 1.35;\n  position: relative;\n  background-color: ", ";\n  transition: all 85ms ease-out;\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0;\n  outline: none;\n  box-shadow: 0 0 0 2px ", ";\n\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &::placeholder {\n    font-size: ", ";\n    color: ", ";\n  }\n\n  ", ";\n"], ["\n  padding: ", ";\n  border-radius: ", ";\n  background: ", ";\n  font-size: ", ";\n  line-height: 1.35;\n  position: relative;\n  background-color: ", ";\n  transition: all 85ms ease-out;\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0;\n  outline: none;\n  box-shadow: 0 0 0 2px ", ";\n\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &::placeholder {\n    font-size: ", ";\n    color: ", ";\n  }\n\n  ", ";\n"]), O.padding("small"), O.radius("small"), O.color.grey(0), O.font.size(2), O.color.grey(), O.color.grey(2), function (n) {
    return n.error ? O.color.error() : "transparent";
  }, O.color.grey(3), function (n) {
    return n.error ? O.color.error() : O.color.primary();
  }, O.font.size(2), O.color.grey(3), function (n) {
    return n.small && g.css(z = z || E(["\n      font-size: ", ";\n      padding: 8px ", ";\n    "], ["\n      font-size: ", ";\n      padding: 8px ", ";\n    "]), O.font.size(1), O.padding("small"));
  }),
      P = t.input(S = S || E(["\n  ", "\n"], ["\n  ", "\n"]), B),
      j = t.input(T = T || E(["\n  ", "\n"], ["\n  ", "\n"]), B),
      W = t.textarea(L = L || E(["\n  ", ";\n  resize: vertical;\n  height: 160px;\n"], ["\n  ", ";\n  resize: vertical;\n  height: 160px;\n"]), B);
  (D = F = F || {}).Hex = "hex", D.RGB = "rgb";

  function V(n) {
    if (!n) return null;
    var e = r.get(n);
    if (!e) return null;
    var t = e.value;
    return {
      r: t[0],
      g: t[1],
      b: t[2],
      a: t[3]
    };
  }

  var G,
      U,
      K,
      Y,
      Z,
      Q,
      J,
      X,
      nn,
      en,
      tn,
      rn,
      on,
      an,
      sn = ((I = {})[F.RGB] = {
    getLabel: function getLabel(n) {
      return "R" + n.r + " G" + n.g + " B" + n.b;
    },
    getValue: function getValue(n) {
      var e = [n.r, n.g, n.b, n.a];
      return r.to.rgb(e);
    },
    parse: V
  }, I[F.Hex] = {
    getLabel: function getLabel(n) {
      return function (n) {
        return "#" + ((1 << 24) + (n.r << 16) + (n.g << 8) + n.b).toString(16).slice(1);
      }(n);
    },
    getValue: function getValue(n) {
      var e = [n.r, n.g, n.b, n.a];
      return r.to.hex(e);
    },
    parse: V
  }, I),
      ln = t(function (n) {
    var e = n.colorRGBA,
        t = n.colorFormat,
        r = (n.unselectable, _(n, ["colorRGBA", "colorFormat", "unselectable"]));
    return R.createElement("div", _H({}, r), R.createElement("div", {
      className: "swatch-inner"
    }, e ? sn[t].getLabel(e) : "Click to add color"));
  })(G = G || E(["\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  cursor: pointer;\n  width: 100%;\n  margin: 0;\n\n  > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: ", ";\n    font-weight: bold;\n\n    width: 100%;\n    height: 40px;\n    border-radius: ", ";\n    box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.075);\n    background: ", ";\n    color: ", ";\n    transition: all ", " ease-out;\n  }\n\n  &:hover {\n    > div {\n      opacity: 0.6;\n    }\n  }\n"], ["\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  cursor: pointer;\n  width: 100%;\n  margin: 0;\n\n  > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: ", ";\n    font-weight: bold;\n\n    width: 100%;\n    height: 40px;\n    border-radius: ", ";\n    box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.075);\n    background: ", ";\n    color: ", ";\n    transition: all ", " ease-out;\n  }\n\n  &:hover {\n    > div {\n      opacity: 0.6;\n    }\n  }\n"]), O.color.grey(2), O.radius("big"), O.shadow("small"), O.font.size(1), O.radius("big"), function (n) {
    return n.colorRGBA ? "rgba(" + n.colorRGBA.r + ", " + n.colorRGBA.g + ", " + n.colorRGBA.b + ", " + n.colorRGBA.a + ")" : "#fff";
  }, function (n) {
    return function (n) {
      return !n || 186 < .299 * n.r + .587 * n.g + .114 * n.b ? "#000000" : "#ffffff";
    }(n.colorRGBA);
  }, O.timing("short")),
      cn = g.keyframes(U = U || E(["\n  0% {\n    transform: translate3d(-50%, 5px, 0) scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: translate3d(-50%, 5px, 0) scale3d(1, 1, 1);\n  }\n"], ["\n  0% {\n    transform: translate3d(-50%, 5px, 0) scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: translate3d(-50%, 5px, 0) scale3d(1, 1, 1);\n  }\n"])),
      dn = t.div(K = K || E(["\n  position: absolute;\n  left: 50%;\n  transform: translate3d(-50%, 5px, 0) scale3d(1, 1, 1);\n  transform-origin: 50% -8px;\n  animation: ", " 85ms ease-out both 1;\n  z-index: 900;\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    margin-top: 2px;\n    transform: translate3d(-50%, -100%, 0);\n    width: 16px;\n    height: 13px;\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n    background-color: white;\n    z-index: 100;\n  }\n"], ["\n  position: absolute;\n  left: 50%;\n  transform: translate3d(-50%, 5px, 0) scale3d(1, 1, 1);\n  transform-origin: 50% -8px;\n  animation: ", " 85ms ease-out both 1;\n  z-index: 900;\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    margin-top: 2px;\n    transform: translate3d(-50%, -100%, 0);\n    width: 16px;\n    height: 13px;\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n    background-color: white;\n    z-index: 100;\n  }\n"]), cn),
      un = t.div(Y = Y || E(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 800;\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 800;\n"])),
      pn = "transparent",
      fn = ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"],
      mn = {
    sketch: function sketch(n) {
      return R.createElement(e.SketchPicker, {
        presetColors: n.presetColors,
        color: n.color,
        onChange: n.onChange,
        disableAlpha: n.disableAlpha,
        width: n.width
      });
    },
    block: function block(n) {
      return R.createElement(e.BlockPicker, {
        colors: n.presetColors,
        color: n.color,
        onChange: n.onChange,
        width: n.width
      });
    }
  },
      hn = t.div(Z = Z || E(["\n  display: inline-block;\n  position: relative;\n  width: 40px;\n  height: 20px;\n  margin: 0;\n"], ["\n  display: inline-block;\n  position: relative;\n  width: 40px;\n  height: 20px;\n  margin: 0;\n"])),
      gn = t.label(Q = Q || E(["\n  background: none;\n  color: inherit;\n  padding: 0;\n  opacity: ", ";\n  outline: none;\n  width: 48px;\n  height: 28px;\n  pointer-events: ", ";\n"], ["\n  background: none;\n  color: inherit;\n  padding: 0;\n  opacity: ", ";\n  outline: none;\n  width: 48px;\n  height: 28px;\n  pointer-events: ", ";\n"]), function (n) {
    return n.disabled ? "0.4" : "1";
  }, function (n) {
    return n.disabled ? "none" : "inherit";
  }),
      bn = t.div(J = J || E(["\n  position: relative;\n  width: 48px;\n  height: 28px;\n  border-radius: ", ";\n  background-color: white;\n  border: 1px solid ", ";\n  pointer-events: none;\n  margin-left: -2px;\n  span {\n    position: absolute;\n    border-radius: ", ";\n    left: 2px;\n    top: 50%;\n    width: calc(28px - 6px);\n    height: calc(28px - 6px);\n    background: ", ";\n    transform: translate3d(", ", -50%, 0);\n    transition: all 150ms ease-out;\n  }\n"], ["\n  position: relative;\n  width: 48px;\n  height: 28px;\n  border-radius: ", ";\n  background-color: white;\n  border: 1px solid ", ";\n  pointer-events: none;\n  margin-left: -2px;\n  span {\n    position: absolute;\n    border-radius: ", ";\n    left: 2px;\n    top: 50%;\n    width: calc(28px - 6px);\n    height: calc(28px - 6px);\n    background: ", ";\n    transform: translate3d(", ", -50%, 0);\n    transition: all 150ms ease-out;\n  }\n"]), O.radius(), O.color.grey(2), O.radius(), function (n) {
    return n.checked ? O.color.primary() : O.color.grey(3);
  }, function (n) {
    return n.checked ? "20px" : "0";
  }),
      vn = t.input(X = X || E(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 48px;\n  height: 28px;\n  opacity: 0;\n  margin: 0;\n  cursor: ", ";\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 48px;\n  height: 28px;\n  opacity: 0;\n  margin: 0;\n  cursor: ", ";\n"]), function (n) {
    return n.disabled ? "not-allowed" : "pointer";
  }),
      kn = t.div(nn = nn || E(["\n  display: block;\n  position: relative;\n\n  select {\n    display: block;\n    font-family: inherit;\n    max-width: 100%;\n    padding: ", ";\n    border-radius: ", ";\n    background: ", ";\n    font-size: ", ";\n    line-height: 1.35;\n    position: relative;\n    background-color: ", ";\n    transition: all 85ms ease-out;\n    border: 1px solid ", ";\n    width: 100%;\n    margin: 0;\n    appearance: none;\n    outline: none;\n    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');\n    background-repeat: no-repeat;\n    background-position: right 0.7em top 50%;\n    background-size: 0.65em auto;\n  }\n"], ["\n  display: block;\n  position: relative;\n\n  select {\n    display: block;\n    font-family: inherit;\n    max-width: 100%;\n    padding: ", ";\n    border-radius: ", ";\n    background: ", ";\n    font-size: ", ";\n    line-height: 1.35;\n    position: relative;\n    background-color: ", ";\n    transition: all 85ms ease-out;\n    border: 1px solid ", ";\n    width: 100%;\n    margin: 0;\n    appearance: none;\n    outline: none;\n    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');\n    background-repeat: no-repeat;\n    background-position: right 0.7em top 50%;\n    background-size: 0.65em auto;\n  }\n"]), O.padding("small"), O.radius("small"), O.color.grey(0), O.font.size(2), O.color.grey(), O.color.grey(2)),
      wn = t.div(en = en || E(["\n  border-radius: ", ";\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  cursor: pointer;\n"], ["\n  border-radius: ", ";\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  cursor: pointer;\n"]), O.radius("small")),
      xn = t.div(tn = tn || E(["\n  text-align: center;\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: ", ";\n  font-weight: 500;\n  transition: all 85ms ease-out;\n  &:hover {\n    opacity: 0.6;\n  }\n"], ["\n  text-align: center;\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: ", ";\n  font-weight: 500;\n  transition: all 85ms ease-out;\n  &:hover {\n    opacity: 0.6;\n  }\n"]), O.radius("small"), O.color.grey(2), O.color.grey(4), O.font.size(2)),
      yn = t.img(rn = rn || E(["\n  max-width: 100%;\n  min-height: 100px;\n  border-radius: ", ";\n  transition: opacity ", " ease-out;\n  margin: 0;\n  display: block;\n  background-color: #e1ddec;\n  background-image: url(\"data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='40px' height='50px' viewBox='0 0 40 50' style='enable-background:new 0 0 40 50;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cdefs%3E%3C/defs%3E%3Cpath class='st0' d='M16.09,24.97c-3.31,0.55-6.16-2.09-5.57-5.16c0.34-1.73,1.82-3.14,3.68-3.5c3.39-0.66,6.37,2.11,5.67,5.25 C19.48,23.28,17.96,24.66,16.09,24.97z M1.88,26.75c0-7.69,0-15.38,0-23.07C2,3.64,1.97,3.53,1.99,3.45c0.5-1.7,1.64-2.82,3.48-3.31 C5.57,0.12,5.71,0.14,5.75,0c7.31,0,14.63,0,21.94,0c0.03,0.1,0.12,0.08,0.2,0.1c0.96,0.2,1.77,0.63,2.47,1.28 c2.72,2.52,5.44,5.05,8.16,7.57c0.68,0.63,1.14,1.38,1.37,2.24c0.02,0.08-0.02,0.19,0.11,0.23c0,5.11,0,10.22,0,15.34h-4.76 c0-3.38,0-6.75,0-10.13c0-0.35-0.1-0.43-0.46-0.43c-3.21,0.01-6.42,0.01-9.63,0.01c-1.65,0-2.62-0.9-2.62-2.42 c0-2.94-0.01-5.89,0.01-8.83c0-0.46-0.14-0.54-0.6-0.53c-4.91,0.02-9.83,0.02-14.74,0c-0.44,0-0.57,0.09-0.57,0.52 c0.02,6.21,0.01,12.42,0.01,18.63c0,1.06,0,2.12,0,3.18H1.88z M27.28,11.46c0,0.31,0.14,0.34,0.41,0.34c2.25-0.01,4.5,0,6.75-0.01 c0.09,0,0.2,0.04,0.24,0c-2.46-2.28-4.92-4.56-7.39-6.85C27.29,7.1,27.3,9.28,27.28,11.46z M33.37,29.61c0,5.18-0.01,10.37,0,15.55 c0,0.35-0.1,0.43-0.46,0.43c-9.23-0.01-18.46-0.01-27.69,0c-0.44,0-0.45-0.17-0.45-0.48c0.01-5.17,0-10.33,0-15.5H0 c0,5.6,0,11.19,0,16.79c0.17,0.09,0.15,0.26,0.19,0.4c0.57,1.85,2.39,3.18,4.47,3.19c9.6,0.01,19.2,0.01,28.81,0 c2.08,0,3.89-1.33,4.47-3.19c0.04-0.14,0.02-0.31,0.19-0.4c0-5.6,0-11.19,0-16.79H33.37z M29.75,42.62c0.34,0,0.44-0.06,0.44-0.4 c-0.01-3.68-0.01-4.6-0.01-8.28c0-0.25-0.08-0.43-0.28-0.6c-0.62-0.55-1.22-1.13-1.83-1.69c-0.79-0.73-1.36-0.74-2.15-0.01 c-2.71,2.52-5.43,5.03-8.13,7.55c-0.26,0.25-0.39,0.24-0.65,0c-1.13-1.08-2.28-2.13-3.43-3.19c-0.7-0.65-1.31-0.65-2.01,0 c-1.16,1.07-2.31,2.15-3.48,3.22c-0.2,0.19-0.29,0.37-0.29,0.64c0.01,1.69,0.03,0.61,0,2.3c-0.01,0.41,0.14,0.46,0.53,0.46 c3.52-0.01,7.05-0.01,10.57-0.01C22.6,42.61,26.17,42.61,29.75,42.62z'/%3E%3C/svg%3E\");\n  background-size: auto;\n  background-position: center center;\n  background-repeat: no-repeat;\n"], ["\n  max-width: 100%;\n  min-height: 100px;\n  border-radius: ", ";\n  transition: opacity ", " ease-out;\n  margin: 0;\n  display: block;\n  background-color: #e1ddec;\n  background-image: url(\"data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='40px' height='50px' viewBox='0 0 40 50' style='enable-background:new 0 0 40 50;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cdefs%3E%3C/defs%3E%3Cpath class='st0' d='M16.09,24.97c-3.31,0.55-6.16-2.09-5.57-5.16c0.34-1.73,1.82-3.14,3.68-3.5c3.39-0.66,6.37,2.11,5.67,5.25 C19.48,23.28,17.96,24.66,16.09,24.97z M1.88,26.75c0-7.69,0-15.38,0-23.07C2,3.64,1.97,3.53,1.99,3.45c0.5-1.7,1.64-2.82,3.48-3.31 C5.57,0.12,5.71,0.14,5.75,0c7.31,0,14.63,0,21.94,0c0.03,0.1,0.12,0.08,0.2,0.1c0.96,0.2,1.77,0.63,2.47,1.28 c2.72,2.52,5.44,5.05,8.16,7.57c0.68,0.63,1.14,1.38,1.37,2.24c0.02,0.08-0.02,0.19,0.11,0.23c0,5.11,0,10.22,0,15.34h-4.76 c0-3.38,0-6.75,0-10.13c0-0.35-0.1-0.43-0.46-0.43c-3.21,0.01-6.42,0.01-9.63,0.01c-1.65,0-2.62-0.9-2.62-2.42 c0-2.94-0.01-5.89,0.01-8.83c0-0.46-0.14-0.54-0.6-0.53c-4.91,0.02-9.83,0.02-14.74,0c-0.44,0-0.57,0.09-0.57,0.52 c0.02,6.21,0.01,12.42,0.01,18.63c0,1.06,0,2.12,0,3.18H1.88z M27.28,11.46c0,0.31,0.14,0.34,0.41,0.34c2.25-0.01,4.5,0,6.75-0.01 c0.09,0,0.2,0.04,0.24,0c-2.46-2.28-4.92-4.56-7.39-6.85C27.29,7.1,27.3,9.28,27.28,11.46z M33.37,29.61c0,5.18-0.01,10.37,0,15.55 c0,0.35-0.1,0.43-0.46,0.43c-9.23-0.01-18.46-0.01-27.69,0c-0.44,0-0.45-0.17-0.45-0.48c0.01-5.17,0-10.33,0-15.5H0 c0,5.6,0,11.19,0,16.79c0.17,0.09,0.15,0.26,0.19,0.4c0.57,1.85,2.39,3.18,4.47,3.19c9.6,0.01,19.2,0.01,28.81,0 c2.08,0,3.89-1.33,4.47-3.19c0.04-0.14,0.02-0.31,0.19-0.4c0-5.6,0-11.19,0-16.79H33.37z M29.75,42.62c0.34,0,0.44-0.06,0.44-0.4 c-0.01-3.68-0.01-4.6-0.01-8.28c0-0.25-0.08-0.43-0.28-0.6c-0.62-0.55-1.22-1.13-1.83-1.69c-0.79-0.73-1.36-0.74-2.15-0.01 c-2.71,2.52-5.43,5.03-8.13,7.55c-0.26,0.25-0.39,0.24-0.65,0c-1.13-1.08-2.28-2.13-3.43-3.19c-0.7-0.65-1.31-0.65-2.01,0 c-1.16,1.07-2.31,2.15-3.48,3.22c-0.2,0.19-0.29,0.37-0.29,0.64c0.01,1.69,0.03,0.61,0,2.3c-0.01,0.41,0.14,0.46,0.53,0.46 c3.52-0.01,7.05-0.01,10.57-0.01C22.6,42.61,26.17,42.61,29.75,42.62z'/%3E%3C/svg%3E\");\n  background-size: auto;\n  background-position: center center;\n  background-repeat: no-repeat;\n"]), O.radius("small"), O.timing("short")),
      Cn = t(O.IconButton)(on = on || E(["\n  top: 8px;\n  right: 8px;\n  position: absolute;\n  &:not(:hover) {\n    fill: ", ";\n    background-color: transparent;\n    border-color: transparent;\n  }\n"], ["\n  top: 8px;\n  right: 8px;\n  position: absolute;\n  &:not(:hover) {\n    fill: ", ";\n    background-color: transparent;\n    border-color: transparent;\n  }\n"]), O.color.grey()),
      _n = t.div(an = an || E(["\n  background-color: ", ";\n  position: relative;\n  border-radius: ", ";\n  overflow: hidden;\n  background-color: ", ";\n  &:hover {\n    ", " {\n      opacity: 0.6;\n    }\n  }\n"], ["\n  background-color: ", ";\n  position: relative;\n  border-radius: ", ";\n  overflow: hidden;\n  background-color: ", ";\n  &:hover {\n    ", " {\n      opacity: 0.6;\n    }\n  }\n"]), O.color.grey(4), O.radius("small"), O.color.grey(8), yn);

  function Mn(n) {
    return new RegExp("(^|[^" + n + "])" + n + "([^\r\n\t\f" + n + " ](.*[^\r\n\t\f" + n + " ])?)" + n);
  }

  var En = function En(n) {
    return new RegExp("" + n + n + "([^\r\n\t\f" + n + "} ](.*[^\r\n\t\f" + n + " ])?)" + n + n);
  },
      zn = En("\\*"),
      An = Mn("\\*"),
      Sn = En("~"),
      Tn = Mn("_"),
      Ln = Mn("`");

  function In(n) {
    var e,
        t,
        r = [];
    return (e = n.nodes.blockquote) && r.push(function (n) {
      return d.wrappingInputRule(/^\s*>\s$/, n);
    }(e)), (e = n.nodes.ordered_list) && r.push(function (n) {
      return d.wrappingInputRule(/^(\d+)\.\s$/, n, function (n) {
        return {
          order: +n[1]
        };
      }, function (n, e) {
        return e.childCount + e.attrs.order == +n[1];
      });
    }(e)), (e = n.nodes.bullet_list) && r.push(function (n) {
      return d.wrappingInputRule(/^\s*([-+*])\s$/, n);
    }(e)), (e = n.nodes.code_block) && r.push(function (n) {
      return d.textblockTypeInputRule(/^```([a-zA-Z]*)? $/, n, function (n) {
        var e = n[1];
        return e ? {
          params: e
        } : {};
      });
    }(e)), (e = n.nodes.heading) && r.push(function (n, e) {
      return d.textblockTypeInputRule(new RegExp("^(#{1," + e + "})\\s$"), n, function (n) {
        return {
          level: n[1].length
        };
      });
    }(e, 6)), (e = n.nodes.horizontal_rule) && r.push(function (o) {
      return new d.InputRule(/^(---|___|\*\*\*)$/, function (n, e, t, r) {
        return n.tr.replaceRangeWith(t, r, o.create());
      });
    }(e)), (t = n.marks.strong) && (r.push(function (n) {
      return Fn(zn, n, {});
    }(t)), r.push(function (n) {
      return Fn(En("_"), n, {});
    }(t))), (t = n.marks.s) && r.push(function (n) {
      return Fn(Sn, n, {});
    }(t)), (t = n.marks.em) && (r.push(function (n) {
      return Dn(An, n, {});
    }(t)), r.push(function (n) {
      return Dn(Tn, n, {});
    }(t))), (t = n.marks.code) && r.push(function (n) {
      return Dn(Ln, n, {});
    }(t)), r;
  }

  function Fn(n, l, c) {
    return new d.InputRule(n, function (n, e, t, r) {
      var o = c instanceof Function ? c(e) : c,
          i = n.tr;

      if (e[1]) {
        var a = t + e[0].indexOf(e[1]),
            s = a + e[1].length;
        s < r && i["delete"](s, r), t < a && i["delete"](t, a), r = t + e[1].length;
      }

      return i.addMark(t, r, l.create(o)), i.removeStoredMark(l), i;
    });
  }

  function Dn(n, e, t) {
    var o = function (p, f) {
      return function (n, e, t, r, o) {
        var i = f instanceof Function ? f(t) : f,
            a = n.tr,
            s = t[1].length;

        if (t[2]) {
          var l = r + 1 + s,
              c = l + t[2].length,
              d = [l - 1, l],
              u = [c, c + (function (n, e) {
            try {
              return n.doc.textBetween(e + 1, e + 2);
            } catch (n) {
              return "";
            }
          }(n, c) ? 0 : 1)];
          a["delete"].apply(a, u), a["delete"].apply(a, d), o = r + t[2].length + s;
        }

        return a.addMark(r + s, o, p.create(i)), a.removeStoredMark(p), e && e(a), a;
      };
    }(e, t);

    return new d.InputRule(n, function (n, e, t, r) {
      return o(n, null, e, t, r);
    });
  }

  var Bn = "undefined" != typeof navigator && /Mac/.test(navigator.platform);
  var Pn,
      On = (C(Rn, Pn = R.Component), Rn.prototype.componentDidMount = function () {
    document.addEventListener("keydown", this.onEscapeCancel);
  }, Rn.prototype.componentWillUnmount = function () {
    document.removeEventListener("keydown", this.onEscapeCancel);
  }, Rn.prototype.componentWillReceiveProps = function (n) {
    var e = n.href,
        t = n.title;
    this.setState(function () {
      return {
        href: e,
        title: t
      };
    });
  }, Rn.prototype.render = function () {
    var n = this.props,
        e = n.removeLink,
        t = n.style,
        r = void 0 === t ? {} : t,
        o = this.state,
        i = o.href,
        a = o.title;
    return R.createElement(Un, {
      style: _H({}, r)
    }, R.createElement(Kn, null, "Title"), R.createElement(Yn, {
      placeholder: "Enter Title",
      type: "text",
      value: a,
      onChange: this.setTitle,
      onKeyPress: this.onEnterSave
    }), R.createElement(Kn, null, "URL"), R.createElement(Yn, {
      placeholder: "Enter URL",
      autoFocus: !0,
      type: "text",
      value: i,
      onChange: this.setHref,
      onKeyPress: this.onEnterSave
    }), R.createElement(Zn, null, R.createElement(Jn, {
      onClick: e
    }, "Delete"), R.createElement(Qn, {
      onClick: this.save
    }, "Save")));
  }, Rn);

  function Rn() {
    var t = null !== Pn && Pn.apply(this, arguments) || this;
    return t.state = {
      href: t.props.href || "",
      title: t.props.title || ""
    }, t.setHref = function (n) {
      var e = n.target.value;
      return t.setState(function () {
        return {
          href: e
        };
      });
    }, t.setTitle = function (n) {
      var e = n.target.value;
      return t.setState(function () {
        return {
          title: e
        };
      });
    }, t.save = function () {
      return t.props.onChange(t.state);
    }, t.onEnterSave = function (n) {
      "Enter" === n.key && t.save();
    }, t.onEscapeCancel = function (n) {
      27 === n.keyCode && t.props.cancel();
    }, t;
  }

  var Nn,
      qn,
      $n,
      Hn,
      jn,
      Wn,
      Vn,
      Gn = g.keyframes(Nn = Nn || E(["\n  0% {\n    transform: scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: scale3d(1, 1, 1);\n  }\n"], ["\n  0% {\n    transform: scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: scale3d(1, 1, 1);\n  }\n"])),
      Un = t.div(qn = qn || E(["\n  background-color: #f6f6f9;\n  position: relative;\n  height: max-content;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  filter: drop-shadow(0px 4px 8px rgba(48, 48, 48, 0.1))\n    drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.12));\n  transform-origin: 50% 0;\n  animation: ", " 85ms ease-out both 1;\n  overflow: visible;\n  padding: 12px;\n  z-index: 10;\n"], ["\n  background-color: #f6f6f9;\n  position: relative;\n  height: max-content;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  filter: drop-shadow(0px 4px 8px rgba(48, 48, 48, 0.1))\n    drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.12));\n  transform-origin: 50% 0;\n  animation: ", " 85ms ease-out both 1;\n  overflow: visible;\n  padding: 12px;\n  z-index: 10;\n"]), O.radius("small"), O.color.grey(2), Gn),
      Kn = t.label($n = $n || E(["\n  display: block;\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: ", ";\n  margin-bottom: 3px;\n"], ["\n  display: block;\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: ", ";\n  margin-bottom: 3px;\n"]), O.font.size(1), O.color.grey(8)),
      Yn = t.input(Hn = Hn || E(["\n  position: relative;\n  background-color: white;\n  border-radius: ", ";\n  font-size: ", ";\n  line-height: 1.35;\n  transition: all 85ms ease-out;\n  padding: 8px 12px;\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0 0 8px 0;\n  outline: none;\n  box-shadow: 0 0 0 2px transparent;\n\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px #0084ff;\n  }\n\n  &::placeholder {\n    font-size: ", ";\n    color: #cfd3d7;\n  }\n"], ["\n  position: relative;\n  background-color: white;\n  border-radius: ", ";\n  font-size: ", ";\n  line-height: 1.35;\n  transition: all 85ms ease-out;\n  padding: 8px 12px;\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0 0 8px 0;\n  outline: none;\n  box-shadow: 0 0 0 2px transparent;\n\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px #0084ff;\n  }\n\n  &::placeholder {\n    font-size: ", ";\n    color: #cfd3d7;\n  }\n"]), O.radius("small"), O.font.size(1), O.color.grey(2), O.color.grey(3), O.font.size(2)),
      Zn = t.div(jn = jn || E(["\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 4px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 4px;\n"])),
      Qn = t.button(Wn = Wn || E(["\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  background-color: #0084ff;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 85ms ease-out;\n  font-size: ", ";\n  padding: 8px 20px;\n  margin-left: 8px;\n  &:hover {\n    background-color: #2296fe;\n  }\n  &:active {\n    background-color: #0574e4;\n  }\n"], ["\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  background-color: #0084ff;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 85ms ease-out;\n  font-size: ", ";\n  padding: 8px 20px;\n  margin-left: 8px;\n  &:hover {\n    background-color: #2296fe;\n  }\n  &:active {\n    background-color: #0574e4;\n  }\n"]), O.radius(), O.font.size(0)),
      Jn = t(Qn)(Vn = Vn || E(["\n  background-color: white;\n  border: 1px solid ", ";\n  color: #0084ff;\n  &:hover {\n    background-color: #f6f6f9;\n    opacity: 1;\n  }\n"], ["\n  background-color: white;\n  border: 1px solid ", ";\n  color: #0084ff;\n  &:hover {\n    background-color: #f6f6f9;\n    opacity: 1;\n  }\n"]), O.color.grey(2));

  function Xn(n, e) {
    var t = n.schema.marks.link,
        r = n.selection.$cursor,
        o = n.tr;
    if (!r) return !1;
    var i = n.doc.nodeAt(r.pos);
    if (!i || !t.isInSet(i.marks)) return !1;

    if (e) {
      var a = function (e, n) {
        var t = (window.$cursor = e).index(),
            r = e.indexAfter();
        t === e.parent.childCount && (t--, r--);

        function o(n) {
          return i.isInSet(e.parent.child(n).marks);
        }

        var i = n.isInSet(e.parent.child(t).marks);

        for (; 0 < t && o(t - 1);) {
          t--;
        }

        for (; r < e.parent.childCount && o(r);) {
          r++;
        }

        for (var a = e.start(), s = a, l = 0; l < r; l++) {
          var c = e.parent.child(l).nodeSize;
          l < t && (a += c), s += c;
        }

        return {
          from: a,
          to: s,
          mark: i
        };
      }(r, t),
          s = a.from,
          l = a.to,
          c = a.mark,
          d = _H(_H({}, c ? c.attrs : {}), {
        editing: "editing",
        creating: ""
      });

      o.addMark(s, l, t.create(d)), e(o.scrollIntoView());
    }

    return !0;
  }

  function ne(n, e) {
    var o = [],
        i = n.schema.marks.link;
    if (n.doc.descendants(function (n, e) {
      var t = i.isInSet(n.marks);

      if (t && "editing" == t.attrs.editing) {
        var r = _H(_H({}, t.attrs), {
          editing: "",
          creating: ""
        });

        o.push({
          from: e,
          to: e + n.nodeSize,
          mark: i.create(r)
        });
      }
    }), !o.length) return !1;

    if (e) {
      var a = n.tr;
      o.forEach(function (n) {
        var e = n.from,
            t = n.to,
            r = n.mark;
        return a.addMark(e, t, r);
      }), e(a);
    }

    return !0;
  }

  function ee(n, e) {
    var t = n.schema.nodes.horizontal_rule;
    return e && e(n.tr.replaceSelectionWith(t.create()).scrollIntoView()), !0;
  }

  function te(n) {
    for (var e = n, t = e.offsetTop; e.offsetParent;) {
      t += (e = e.offsetParent).offsetTop;
    }

    return t;
  }

  function re(n) {
    for (var e = n, t = e.offsetLeft; e.offsetParent;) {
      t += (e = e.offsetParent).offsetLeft;
    }

    return t;
  }

  var oe = (ie.prototype.component = function () {
    if (this.clickTarget) {
      var n = function (n, e, t) {
        var r = n.offsetWidth,
            o = re(n),
            i = e.parentElement.offsetWidth,
            a = re(e),
            s = o - a + r / 2 - t / 2;
        return s < -a ? "-8px" : i < s + t ? "calc(" + (s - (s + t - i)) + "px + 8px)" : s + "px";
      }(this.clickTarget, this.renderTarget, 240),
          e = "calc(32px + " + (te(this.clickTarget) - te(this.renderTarget)) + "px)",
          t = function (n, e) {
        var t = n.offsetWidth,
            r = re(n),
            o = re(e);
        return r - o + t / 2 + "px";
      }(this.clickTarget, this.renderTarget);

      return R.createElement(g.ThemeProvider, {
        theme: this.theme
      }, R.createElement(O.TinaReset, null, R.createElement(le, null, R.createElement(ce, {
        offset: t,
        top: e
      }), R.createElement(On, {
        style: {
          left: n,
          top: e,
          minWidth: "240px"
        },
        removeLink: this.removeLink,
        onChange: this.onChange,
        href: this.href,
        title: this.title,
        cancel: this.cancel
      }))));
    }
  }, Object.defineProperty(ie.prototype, "href", {
    get: function get() {
      return this.clickTarget.getAttribute("href");
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(ie.prototype, "title", {
    get: function get() {
      return this.clickTarget.getAttribute("title");
    },
    enumerable: !0,
    configurable: !0
  }), ie);

  function ie(n, e, t) {
    var r = this;
    this.renderTarget = n, this.view = e, this.theme = t, this.clickTarget = null, this.render = function (n) {
      r.clickTarget = n, w.render(r.component(), r.renderTarget);
    }, this.unmount = function () {
      return w.unmountComponentAtNode(r.renderTarget);
    }, this.cancel = function () {
      return ne(r.view.state, r.view.dispatch);
    }, this.removeLink = function () {
      return function (n, e) {
        if (e) {
          var i = n.schema.marks.link,
              a = n.tr;
          n.doc.descendants(function (n, e) {
            var t = i.isInSet(n.marks);

            if (t && t.attrs.editing) {
              var r = e,
                  o = r + n.nodeSize;
              a.removeMark(r, o, t);
            }
          }), e(a.scrollIntoView());
        }

        return !0;
      }(r.view.state, r.view.dispatch);
    }, this.onChange = function (n) {
      !function (n, e, i) {
        if (e) {
          var a = n.schema.marks.link,
              s = n.tr;
          n.doc.descendants(function (n, e) {
            var t = a.isInSet(n.marks);

            if (t && t.attrs.editing) {
              var r = e,
                  o = r + n.nodeSize;
              s.addMark(r, o, a.create(i));
            }
          }), e(s.scrollIntoView());
        }
      }(r.view.state, r.view.dispatch, _H(_H({}, n), {
        editing: "",
        creating: ""
      }));
    };
  }

  var ae,
      se,
      le = t.div(ae = ae || E(["\n  position: relative;\n"], ["\n  position: relative;\n"])),
      ce = t.div(se = se || E(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  margin-top: 3px;\n  transform: translate3d(-50%, -100%, 0);\n  width: 16px;\n  height: 13px;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  background-color: #f6f6f9;\n  z-index: 100;\n"], ["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  margin-top: 3px;\n  transform: translate3d(-50%, -100%, 0);\n  width: 16px;\n  height: 13px;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  background-color: #f6f6f9;\n  z-index: 100;\n"]), function (n) {
    return n.top;
  }, function (n) {
    return n.offset;
  });
  var de = (ue.prototype.shouldStopEditing = function (n) {
    var e = this.renderTarget.contains(n),
        t = this.linkBeingEdited && "creating" === this.linkBeingEdited.getAttribute("creating"),
        r = t && !this.skippedLinkControlClick;
    return this.skippedLinkControlClick = !!t, this.visible && !e && !r;
  }, ue.prototype.isValidLink = function (n) {
    for (var e, t = n; !e && t;) {
      "a" === t.tagName.toLowerCase() ? e = t : t = t.parentElement;
    }

    var r = this.view.state.selection.$cursor;
    return e && r ? e : null;
  }, ue.prototype.update = function (n) {
    this.view = n, this.linkBeingEdited = this.view.dom.querySelector("a[editing='editing']"), !this.linkBeingEdited && this.visible && this.unmountLinkForm(), this.linkBeingEdited && !this.visible && this.renderLinkForm(this.linkBeingEdited);
  }, ue.prototype.renderLinkForm = function (n) {
    this.visible = !0, function (n, e) {
      var t = n.state.tr;
      t.setMeta("type", "tinacms/render"), t.setMeta("clickTarget", e), n.dispatch(t);
    }(this.view, n);
  }, ue);

  function ue(n, e, t) {
    var i = this;
    this.view = n, this.schema = e, this.renderTarget = t, this.visible = !1, this.linkBeingEdited = null, this.skippedLinkControlClick = !1, this.destroy = function () {
      document.removeEventListener("click", i.handleClick), window.removeEventListener("resize", i.unmountLinkForm), i.renderTarget.parentElement.removeChild(i.renderTarget);
    }, this.handleClick = function (n) {
      var e = n.target,
          t = i.view.dom.contains(e),
          r = i.isValidLink(e);
      if (i.shouldStopEditing(e) && ne(i.view.state, i.view.dispatch), t && r) if (n.preventDefault(), n.stopPropagation(), n.metaKey) {
        var o = r.getAttribute("href");
        window.open(o || void 0, "_blank");
      } else Xn(i.view.state, i.view.dispatch);
    }, this.unmountLinkForm = function () {
      i.visible = !1, function (n) {
        var e = n.state.tr;
        e.setMeta("type", "tinacms/unmount"), n.dispatch(e);
      }(i.view);
    }, document.addEventListener("click", this.handleClick), window.addEventListener("resize", this.unmountLinkForm);
  }

  var pe = /\bhttps?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:;%_\+.,~#?&//=]*)/g;

  function fe(e, t) {
    var r,
        o,
        i = function (n) {
      var e = document.createElement("div");
      return e.setAttribute("id", n), e.style.width = "0", e.style.height = "0", e;
    }("links");

    return new N.Plugin({
      filterTransaction: function filterTransaction(n) {
        switch (n.getMeta("type")) {
          case "tinacms/render":
            return r.render(n.getMeta("clickTarget")), !1;

          case "tinacms/unmount":
            return r.unmount(), !1;

          default:
            return !0;
        }
      },
      view: function view(n) {
        return function (n, e) {
          if (!e.parentElement) throw new Error("Sibling must not be an orphan!");
          e.parentElement.insertBefore(n, e);
        }(i, n.dom), r = new oe(i, n, t), new de(n, e, i);
      },
      props: {
        transformPasted: function transformPasted(n) {
          return o ? n : new k.Slice(he(n.content), n.openStart, n.openEnd);
        },
        handleKeyDown: function handleKeyDown(n, e) {
          return o = e.shiftKey, !1;
        }
      }
    });
  }

  var me = /\.(jpe?g|png)/,
      he = function he(n) {
    var u = [];
    return n.forEach(function (i) {
      if (i.isText) {
        for (var a = i.text, s = 0, n = void 0, l = i.type.schema.marks.link, c = i.type.schema.nodes.image, d = []; n = pe.exec(a);) {
          var e = n.index,
              t = e + n[0].length;
          d.push({
            start: e,
            end: t
          });
        }

        d.forEach(function (n) {
          var e,
              t = n.start,
              r = n.end;
          0 < t && u.push(i.cut(s, t));
          var o = a.slice(t, r);
          me.test(o) ? (e = {
            src: o,
            title: "",
            alt: ""
          }, u.push(c.create(e))) : (e = {
            href: o,
            title: o
          }, 1 === d.length && (e.editing = "editing", e.creating = "creating"), u.push(i.cut(t, r).mark(l.create(e).addToSet(i.marks)))), s = r;
        }), s < a.length && u.push(i.cut(s));
      } else u.push(i.copy(he(i.content)));
    }), k.Fragment.fromArray(u);
  };

  var ge = function ge(e, n, t, r) {
    var o = n.width,
        i = n.map.findIndex(function (n) {
      return n === e - t.start;
    });
    return new b.CellSelection(r.resolve(n.map[i + o - 1] + t.start), r.resolve(e));
  },
      be = function be(e, n, t, r) {
    var o = n.width,
        i = n.height,
        a = n.map.findIndex(function (n) {
      return n === e - t.start;
    });
    return new b.CellSelection(r.resolve(n.map[a + o * (i - 1)] + t.start), r.resolve(e));
  },
      ve = function ve(n, e, t, r) {
    return new b.CellSelection(r.resolve(e.map[e.map.length - 1] + t.start), r.resolve(n));
  },
      ke = function ke(t, n, r, o) {
    for (var i = [], a = n.map, e = function e(_e2) {
      var n = document.createElement("div");
      n.classList.add("tina_table_header_ext_top"), o && r.ranges.some(function (n) {
        return n.$from.pos === t.start + a[_e2] + 1;
      }) && n.classList.add("tina_table_header_ext_top_selected"), i.push(h.Decoration.widget(t.start + a[_e2] + 1, n));
    }, s = 0; s < n.width; s++) {
      e(s);
    }

    return i;
  },
      we = function we(t, r, o, i) {
    for (var a = [], s = r.map, n = function n(e) {
      var n = document.createElement("div");
      n.classList.add("tina_table_header_ext_left"), i && o.ranges.some(function (n) {
        return n.$from.pos === t.start + s[e * r.width] + 1;
      }) && n.classList.add("tina_table_header_ext_left_selected"), a.push(h.Decoration.widget(t.start + s[e * r.width] + 1, n));
    }, e = 0; e < r.height; e++) {
      n(e);
    }

    return a;
  },
      xe = function xe(n, e, t) {
    var r = [],
        o = document.createElement("div");
    return o.classList.add("tina_table_header_ext_top_left"), e && t && o.classList.add("tina_table_header_ext_top_left_selected"), r.push(h.Decoration.widget(n.start + 2, o)), r;
  },
      ye = new N.PluginKey("table"),
      Ce = new N.Plugin({
    key: ye,
    state: {
      init: function init() {
        return {
          deco: h.DecorationSet.empty
        };
      },
      apply: function apply(n, e, t, r) {
        if (!1 === n.getMeta("image_clicked")) return e;
        var o = r.selection;

        if (o) {
          var i = r.schema.nodes.table,
              a = x.findParentNodeOfType(i)(o);

          if (a) {
            var s = function (n, e) {
              var t = b.TableMap.get(n.node),
                  r = e.isColSelection && e.isColSelection(),
                  o = e.isRowSelection && e.isRowSelection(),
                  i = xe(n, r, o);
              return i = M(i = M(i, ke(n, t, e, r)), we(n, t, e, o));
            }(a, o);

            if (s.length) return {
              deco: h.DecorationSet.create(r.doc, s),
              tableMap: b.TableMap.get(a.node),
              selectedTable: a
            };
          }
        }

        return {
          deco: h.DecorationSet.empty
        };
      }
    },
    props: {
      decorations: function decorations(n) {
        return this.getState(n).deco;
      },
      handleClickOn: function handleClickOn(n, e, t, r, o, i) {
        if (!i) return !1;

        var a = o.target.classList,
            s = n.state,
            l = n.dispatch,
            c = ye.getState(s),
            d = c.tableMap,
            u = c.selectedTable,
            p = function (n, e, t, r, o) {
          return e.includes("tina_table_header_ext_top_left") ? ve(n, t, r, o.doc) : e.includes("tina_table_header_ext_left") ? ge(n, t, r, o.doc) : e.includes("tina_table_header_ext_top") ? be(n, t, r, o.doc) : void 0;
        }(r, a.value, d, u, s);

        return p && l(s.tr.setSelection(p)), !1;
      }
    }
  }),
      _e = new N.PluginKey("image"),
      Me = new N.Plugin({
    key: _e,
    state: {
      init: function init() {
        return {
          selectedImage: void 0
        };
      },
      apply: function apply(n, e) {
        if (e && e.selectedImage) {
          var t = e.selectedImage.pos;
          if (!n.doc.nodeAt(t)) return {};
        }

        var r = n.getMeta("image_clicked");
        return r ? {
          selectedImage: r
        } : !1 === r ? {
          selectedImage: void 0
        } : e;
      }
    },
    props: {
      decorations: function decorations(n) {
        return this.getState(n).deco;
      },
      handleKeyDown: function handleKeyDown(n, e) {
        if ("Escape" === e.key) {
          var t = n.state;
          (0, n.dispatch)(t.tr.setMeta("image_clicked", !1));
        }

        return !1;
      },
      handleClickOn: function handleClickOn(n, e, t, r, o, i) {
        if (!i) return !1;
        var a = n.state,
            s = n.dispatch,
            l = n.state.schema.nodes.image;
        return t.type === l ? s(a.tr.setMeta("image_clicked", {
          pos: r,
          node: t
        })) : s(a.tr.setMeta("image_clicked", !1)), !1;
      }
    }
  });

  function Ee(n, e, t, r, o) {
    return N.EditorState.create({
      schema: n,
      doc: e.nodeFromString(r),
      plugins: [function (n) {
        return d.inputRules({
          rules: In(n)
        });
      }(n), l.keymap(function (t, n) {
        var r = _H({}, v.baseKeymap);

        function o(n, e) {
          r[n] && (e = v.chainCommands(e, r[n])), r[n] = e;
        }

        return o("Enter", v.chainCommands(v.createParagraphNear, v.liftEmptyBlock, v.splitBlock)), function (n, e) {
          return e.filter(function (e) {
            return function (n) {
              return n.__type === e;
            };
          }(n));
        }("wysiwyg:keymap", n).forEach(function (n) {
          var e = !1;
          n.unlessMac && Bn && (e = !0), n.ifMark && !t.marks[n.ifMark] && (e = !0), n.ifNode && !t.nodes[n.ifNode] && (e = !0), n.ifNodes && !n.ifNodes.some(function (n) {
            return t.nodes[n];
          }) && (e = !0), n.onCondition && !n.onCondition(t) && (e = !0), e || o(n.name, n.command(t));
        }), r;
      }(n, t)), s.history(), fe(n, o), i.dropCursor({
        width: 2,
        color: "rgb(33, 224, 158)"
      }), a.gapCursor(), b.tableEditing(), Ce, Me]
    });
  }

  function ze() {}

  var Ae = (Se.prototype.serialize = function (n, e) {
    void 0 === e && (e = {});
    var t = new Le(this.nodes, this.marks, e);
    return t.renderContent(n), t.out;
  }, Se);

  function Se(n, e) {
    this.nodes = n, this.marks = e;
  }

  var Te,
      Le = (Ie.prototype.flushClose = function (n) {
    if (this.closed) {
      if (this.atBlank() || (this.out += "\n"), null == n && (n = 2), 1 < n) {
        var e = this.delim,
            t = /\s+$/.exec(e);
        t && (e = e.slice(0, e.length - t[0].length));

        for (var r = 1; r < n; r++) {
          this.out += e + "\n";
        }
      }

      this.closed = !1;
    }
  }, Ie.prototype.wrapBlock = function (n, e, t, r) {
    var o = this.delim;
    this.write(e || n), this.delim += n, r(), this.delim = o, this.closeBlock(t);
  }, Ie.prototype.atBlank = function () {
    return /(^|\n)$/.test(this.out);
  }, Ie.prototype.ensureNewLine = function () {
    this.atBlank() || (this.out += "\n");
  }, Ie.prototype.write = function (n) {
    this.flushClose(), this.delim && this.atBlank() && (this.out += this.delim), n && (this.out += n);
  }, Ie.prototype.closeBlock = function (n) {
    this.closed = n;
  }, Ie.prototype.text = function (n, e, t) {
    for (var r = n.split("\n"), o = 0; o < r.length; o++) {
      var i = this.atBlank() || this.closed;
      this.write();
      var a = !1 !== e ? this.esc(r[o], i) : r[o];
      a = t ? t(a) : a, this.out += a, o != r.length - 1 && (this.out += "\n");
    }
  }, Ie.prototype.render = function (n, e, t, r) {
    if ("number" == typeof e) throw new Error("!");
    this.nodes[n.type.name](this, n, e, t, r);
  }, Ie.prototype.renderContent = function (r) {
    var o = this;
    r.forEach(function (n, e, t) {
      return o.render(n, r, t);
    });
  }, Ie.prototype.renderInline = function (k, w) {
    function n(n, e, t) {
      void 0 === t && (t = 0);
      var r = n ? n.marks : [],
          o = r.findIndex(function (n) {
        return "code" === n.type.name;
      });
      0 <= o && 1 < r.length && (r = M(r.slice(0, o), r.slice(o + 1, r.length), [r[o]]));
      var i = C;

      if (C = "", n && n.isText && r.some(function (n, e, t) {
        var r = x.marks[n.type.name];
        return !(!r || !r.expelEnclosingWhitespace);
      }) && /^(\s*)(.*?)(\s*)$/.test(n.text || "")) {
        var a = Array.from(/^(\s*)(.*?)(\s*)$/.exec(n.text || "") || []),
            s = a[1],
            l = a[2],
            c = a[3];
        i += s, C = c, (s || c) && ((n = l ? n.withText(l) : null) || (r = y));
      }

      var d = r.length && r[r.length - 1],
          u = d && !1 === x.marks[d.type.name].escape,
          p = r.length - (u ? 1 : 0);

      n: for (var f = 0; f < p; f++) {
        var m = r[f];
        if (!x.marks[m.type.name].mixable) break;

        for (var h = 0; h < y.length; h++) {
          var g = y[h];
          if (!x.marks[g.type.name].mixable) break;

          if (m.eq(g)) {
            h < f ? r = r.slice(0, h).concat(m).concat(r.slice(h, f)).concat(r.slice(f + 1, p)) : f < h && (r = r.slice(0, f).concat(r.slice(f + 1, h)).concat(m).concat(r.slice(h, p)));
            continue n;
          }
        }
      }

      for (var b = 0; b < Math.min(y.length, p) && r[b].eq(y[b]);) {
        ++b;
      }

      for (; b < y.length;) {
        x.text(x.markString(y.pop(), !1, n), !1);
      }

      if (i && x.text(i), n) {
        for (; y.length < p;) {
          var v = r[y.length];
          y.push(v), x.text(x.markString(v, !0, n), !1);
        }

        u && n.isText && d ? x.text(x.markString(d, !1, n) + n.text + x.markString(d, !0, n), !1, w) : x.render(n, k, t, w);
      }
    }

    var x = this,
        y = [],
        C = "";
    k.forEach(n), n(null);
  }, Ie.prototype.renderList = function (r, o, i) {
    var a = this;
    this.closed && this.closed.type == r.type ? this.flushClose(3) : this.inTightList && this.flushClose(1);
    var s = this.options.tightLists,
        n = this.inTightList;
    this.inTightList = !!s, r.forEach(function (n, e, t) {
      t && s && a.flushClose(1), a.wrapBlock(o, i(t), r, function () {
        return a.render(n, r, t);
      });
    }), this.inTightList = n;
  }, Ie.prototype.esc = function (n, e) {
    return n = n.replace(/[`\\~\[\]]/g, "\\$&"), e && (n = n.replace(/^[#\-*+]/, "\\$&").replace(/^(\d+)\./, "$1\\.")), n;
  }, Ie.prototype.quote = function (n) {
    var e = -1 == n.indexOf('"') ? '""' : -1 == n.indexOf("'") ? "''" : "()";
    return e[0] + n + e[1];
  }, Ie.prototype.repeat = function (n, e) {
    for (var t = "", r = 0; r < e; r++) {
      t += n;
    }

    return t;
  }, Ie.prototype.markString = function (n, e, t) {
    var r = this.marks[n.type.name],
        o = e ? r.open : r.close;
    return "string" == typeof o ? o : o(this, n, t);
  }, Ie.prototype.getEnclosingWhitespace = function (n) {
    return {
      leading: (n.match(/^(\s+)/) || [])[0],
      trailing: (n.match(/(\s+)$/) || [])[0]
    };
  }, Ie);

  function Ie(n, e, t) {
    this.nodes = n, this.marks = e, this.delim = this.out = "", this.closed = !1, this.inTightList = !1, this.options = t || {}, void 0 === this.options.tightLists && (this.options.tightLists = !1);
  }

  var Fe = require("lodash.get"),
      De = ((Te = {})["text-align:left"] = "left", Te["text-align:center"] = "center", Te["text-align:right"] = "right", Te),
      Be = {
    left: ":---",
    center: ":---:",
    right: "---:"
  },
      Pe = {
    blockquote: {
      block: "blockquote"
    },
    paragraph: {
      block: "paragraph"
    },
    list_item: {
      block: "list_item"
    },
    bullet_list: {
      block: "bullet_list"
    },
    ordered_list: {
      block: "ordered_list",
      getAttrs: function getAttrs(n) {
        return {
          order: +n.attrGet("order") || 1
        };
      }
    },
    heading: {
      block: "heading",
      getAttrs: function getAttrs(n) {
        return {
          level: +n.tag.slice(1)
        };
      }
    },
    code_block: {
      block: "code_block"
    },
    fence: {
      block: "code_block",
      getAttrs: function getAttrs(n) {
        return {
          params: n.info || ""
        };
      }
    },
    hr: {
      node: "horizontal_rule"
    },
    image: {
      node: "image",
      getAttrs: function getAttrs(n) {
        return {
          src: n.attrGet("src"),
          title: n.attrGet("title") || null,
          alt: n.children[0] && n.children[0].content || null,
          width: n.attrGet("width") || null,
          height: n.attrGet("height") || null
        };
      }
    },
    table: {
      block: "table"
    },
    table_row: {
      block: "table_row"
    },
    table_cell: {
      block: "table_cell",
      getAttrs: function getAttrs(n) {
        var e = "";
        if (n.attrs) for (var t = 0; t < n.attrs.length; t++) {
          "style" === n.attrs[t][0] && (e = n.attrs[t][1]);
        }
        return {
          align: De[e]
        };
      }
    },
    table_header: {
      block: "table_header",
      getAttrs: function getAttrs(n) {
        var e = "";
        if (n.attrs) for (var t = 0; t < n.attrs.length; t++) {
          "style" === n.attrs[t][0] && (e = n.attrs[t][1]);
        }
        return {
          align: De[e]
        };
      }
    },
    hardbreak: {
      node: "hard_break"
    },
    em: {
      mark: "em"
    },
    s: {
      mark: "s"
    },
    strong: {
      mark: "strong"
    },
    link: {
      mark: "link",
      getAttrs: function getAttrs(n) {
        return {
          href: n.attrGet("href"),
          title: n.attrGet("title") || null
        };
      }
    },
    code_inline: {
      mark: "code"
    }
  },
      Oe = {
    blockquote: function blockquote(n, e) {
      n.wrapBlock("> ", null, e, function () {
        return n.renderContent(e);
      });
    },
    code_block: function code_block(n, e) {
      e.attrs.params ? (n.write("```" + e.attrs.params + "\n"), n.text(e.textContent, !1), n.ensureNewLine(), n.write("```"), n.closeBlock(e)) : n.wrapBlock("    ", null, e, function () {
        return n.text(e.textContent, !1);
      });
    },
    heading: function heading(n, e) {
      /\n/.test(e.textContent) && e.attrs.level < 3 ? (n.renderInline(e), n.write("\n"), n.write(1 === e.attrs.level ? "=" : "-")) : (n.write(n.repeat("#", e.attrs.level) + " "), n.renderInline(e)), n.closeBlock(e);
    },
    horizontal_rule: function horizontal_rule(n, e) {
      n.write(e.attrs.markup || "***"), n.closeBlock(e);
    },
    bullet_list: function bullet_list(n, e) {
      n.renderList(e, "  ", function () {
        return (e.attrs.bullet || "*") + " ";
      });
    },
    ordered_list: function ordered_list(t, n) {
      var r = n.attrs.order || 1,
          o = String(r + n.childCount - 1).length,
          e = t.repeat(" ", o + 2);
      t.renderList(n, e, function (n) {
        var e = String(r + n);
        return t.repeat(" ", o - e.length) + e + ". ";
      });
    },
    list_item: function list_item(n, e) {
      n.renderContent(e);
    },
    paragraph: function paragraph(n, e, t, r) {
      n.renderInline(e), n.closeBlock(e);
    },
    image: function image(n, e) {
      var t = "";
      (e.attrs.height || e.attrs.width) && (t = " =" + (e.attrs.width || "") + "x" + (e.attrs.height || ""));
      var r = n.esc(e.attrs.alt || ""),
          o = n.esc(e.attrs.src),
          i = e.attrs.title ? " " + n.quote(e.attrs.title) : "";
      n.write("![" + r + "](" + o + i + t + ")");
    },
    hard_break: function hard_break(n, e, t, r) {
      if (t && "number" == typeof r) for (var o = r + 1; o < t.childCount; o++) {
        if (t.child(o).type != e.type) return void n.write("  \n");
      }
    },
    text: function text(n, e, t, r, o) {
      "string" == typeof e.text && n.text(e.text, !0, o);
    },
    table: function table(i, n) {
      var a = !0;
      n.forEach(function (n) {
        var e = "table_cell" === n.content.child(0).type.name;

        if (a && e) {
          i.write("|");

          for (var t = 0; t < n.childCount; t++) {
            var r = n.content.child(t).attrs.align,
                o = Be[r] || "---";
            i.write(" " + o + " |");
          }

          i.write("\n"), a = !1;
        }

        Oe.table_row(i, n);
      }), i.closeBlock(n);
    },
    table_row: function table_row(n, e) {
      n.write("|"), n.renderContent(e), n.write("\n");
    },
    table_cell: function table_cell(n, e) {
      n.write(" "), n.renderInline(e, function (n) {
        return n.replace(/[\|]/g, "\\$&");
      }), n.write(" |");
    },
    table_header: function table_header(n, e) {
      Oe.table_cell(n, e);
    }
  },
      Re = {
    em: {
      open: "_",
      close: "_",
      mixable: !0,
      expelEnclosingWhitespace: !0
    },
    strong: {
      open: function open(n, e, t) {
        return Fe(t, "text", "").endsWith("*") ? e.openedWith = "__" : "**";
      },
      close: function close(n, e, t) {
        if (e.openedWith) {
          var r = e.openedWith;
          return e.openedWith = null, r;
        }

        return Fe(t, "text", "").endsWith("*") ? "__" : "**";
      },
      mixable: !0,
      expelEnclosingWhitespace: !0
    },
    link: {
      open: "[",
      close: function close(n, e) {
        return "](" + n.esc(e.attrs.href) + (e.attrs.title ? " " + n.quote(e.attrs.title) : "") + ")";
      }
    },
    s: {
      open: "~~",
      close: "~~",
      mixable: !0,
      expelEnclosingWhitespace: !0
    },
    code: {
      open: "`",
      close: "`",
      escape: !1
    }
  };

  function Ne(n) {
    return new Ae(function (n) {
      var e = {};
      return n.nodes.blockquote && (e.blockquote = Oe.blockquote), n.nodes.paragraph && (e.paragraph = Oe.paragraph), n.nodes.list_item && (e.list_item = Oe.list_item), n.nodes.bullet_list && (e.bullet_list = Oe.bullet_list), n.nodes.ordered_list && (e.ordered_list = Oe.ordered_list), n.nodes.heading && (e.heading = Oe.heading), n.nodes.code_block && (e.code_block = Oe.code_block), n.nodes.horizontal_rule && (e.horizontal_rule = Oe.horizontal_rule), n.nodes.image && (e.image = Oe.image), n.nodes.hard_break && (e.hard_break = Oe.hard_break), n.nodes.ordered_list && (e.ordered_list = Oe.ordered_list), n.nodes.bullet_list && (e.bullet_list = Oe.bullet_list), n.nodes.list_item && (e.list_item = Oe.list_item), n.nodes.table && (e.table = Oe.table, e.table_header = Oe.table_header, e.table_row = Oe.table_row, e.table_cell = Oe.table_cell), e.text = Oe.text, e;
    }(n), function (n) {
      return n.marks.em, n.marks.strong, n.marks.link, n.marks.code, Re;
    }(n));
  }

  function qe(n, e, t) {
    var r,
        o = e,
        i = {
      ok: !1,
      pos: e
    };

    for (r = n.charCodeAt(e); e < t && 48 <= r && r <= 57 || 37 === r;) {
      r = n.charCodeAt(++e);
    }

    return i.ok = !0, i.pos = e, i.value = Number(n.slice(o, e)), i;
  }

  function $e(n, e, t) {
    var r,
        o,
        i = n.utils.isSpace,
        a = n.utils.unescapeAll,
        s = e.src,
        l = e.posMax,
        c = t,
        d = {
      ok: !1,
      pos: 0,
      lines: 0,
      str: ""
    };

    if (60 === s.charCodeAt(t)) {
      for (t++; t < l;) {
        if (10 === (r = s.charCodeAt(t)) || i(r)) return d;
        if (62 === r) return d.pos = t + 1, d.str = a(s.slice(c + 1, t)), d.ok = !0, d;
        92 === r && t + 1 < l ? t += 2 : t++;
      }

      return d;
    }

    for (o = 0; t < l;) {
      if (61 == (r = s.charCodeAt(t)) || 34 == r || 39 == r) {
        t--;
        break;
      }

      if (r < 32 || 127 === r) break;
      if (92 === r && t + 1 < l) t += 2;else {
        if (40 === r && o++, 41 === r) {
          if (0 === o) break;
          o--;
        }

        t++;
      }
    }

    return c === t || 0 !== o || (d.str = a(s.slice(c, t)), d.lines = 0, d.pos = t, d.ok = !0), d;
  }

  function He(w) {
    return function (n, e) {
      var t,
          r,
          o,
          i,
          a,
          s,
          l,
          c,
          d,
          u,
          p = null,
          f = null,
          m = "",
          h = n.pos,
          g = n.posMax;
      if (33 !== n.src.charCodeAt(n.pos)) return !1;
      if (91 !== n.src.charCodeAt(n.pos + 1)) return !1;
      var b = n.pos + 2,
          v = w.helpers.parseLinkLabel(n, n.pos + 1, !1);
      if (v < 0) return !1;

      if ((i = v + 1) < g && 40 === n.src.charCodeAt(i)) {
        for (i++; i < g && (32 === (r = n.src.charCodeAt(i)) || 10 === r); i++) {
          ;
        }

        if (g <= i) return !1;

        for ((s = $e(w, n, u = i)).ok && (m = s.str, n.md.validateLink(m) ? i = s.pos : m = ""), u = i; i < g && (32 === (r = n.src.charCodeAt(i)) || 10 === r); i++) {
          ;
        }

        if (s = w.helpers.parseLinkTitle(n.src, i, n.posMax), i < g && u !== i && s.ok) for (l = s.str, i = s.pos; i < g && (32 === (r = n.src.charCodeAt(i)) || 10 === r); i++) {
          ;
        } else l = "";
        if (0 <= i - 1 && 32 === (r = n.src.charCodeAt(i - 1)) && (s = function (n, e, t) {
          var r,
              o = {
            ok: !1,
            pos: 0
          };
          if (t <= e) return o;
          if (61 !== (r = n.charCodeAt(e))) return o;
          if (e++, 120 !== (r = n.charCodeAt(e)) && (r < 48 || 57 < r)) return o;
          var i = qe(n, e, t);
          if (e = i.pos, 120 !== (r = n.charCodeAt(e))) return o;
          var a = qe(n, ++e, t);
          return e = a.pos, o.width = i.value, o.height = a.value, o.pos = e, o.ok = !0, o;
        }(n.src, i, n.posMax)).ok) for (p = s.width, f = s.height, i = s.pos; i < g && (32 === (r = n.src.charCodeAt(i)) || 10 === r); i++) {
          ;
        }
        if (g <= i || 41 !== n.src.charCodeAt(i)) return n.pos = h, !1;
        i++;
      } else {
        if (void 0 === n.env.references) return !1;

        for (; i < g && (32 === (r = n.src.charCodeAt(i)) || 10 === r); i++) {
          ;
        }

        if (i < g && 91 === n.src.charCodeAt(i) ? (u = i + 1, 0 <= (i = w.helpers.parseLinkLabel(n, i)) ? o = n.src.slice(u, i++) : i = v + 1) : i = v + 1, o = o || n.src.slice(b, v), !(a = n.env.references[w.utils.normalizeReference(o)])) return n.pos = h, !1;
        m = a.href, l = a.title;
      }

      if (!e) {
        n.pos = b, n.posMax = v;
        var k = new n.md.inline.State(n.src.slice(b, v), n.md, n.env, d = []);
        k.md.inline.tokenize(k), (c = n.push("image", "img", 0)).attrs = t = [["src", m], ["alt", ""]], c.children = d, l && t.push(["title", l]), null !== p && t.push(["width", p]), null !== f && t.push(["height", f]);
      }

      return n.pos = i, n.posMax = g, !0;
    };
  }

  function je(n) {
    n.inline.ruler.before("emphasis", "image", He(n));
  }

  function We(n) {
    n.inline.ruler.before("emphasis", "link", function (v) {
      return function (n, e) {
        var t,
            r,
            o,
            i,
            a,
            s,
            l,
            c = n.md.utils.normalizeReference,
            d = n.md.utils.isSpace,
            u = "",
            p = n.pos,
            f = !0,
            m = n.pos,
            h = n.posMax;
        if (91 !== n.src.charCodeAt(n.pos)) return !1;
        var g = n.pos + 1,
            b = n.md.helpers.parseLinkLabel(n, n.pos, !0);
        if (b < 0) return !1;

        if ((i = b + 1) < h && 40 === n.src.charCodeAt(i)) {
          for (f = !1, i++; i < h && (d(r = n.src.charCodeAt(i)) || 10 === r); i++) {
            ;
          }

          if (h <= i) return !1;

          for ((a = $e(v, n, p = i)).ok && (u = a.str, n.md.validateLink(u) ? i = a.pos : u = ""), p = i; i < h && (d(r = n.src.charCodeAt(i)) || 10 === r); i++) {
            ;
          }

          if (a = n.md.helpers.parseLinkTitle(n.src, i, n.posMax), i < h && p !== i && a.ok) for (l = a.str, i = a.pos; i < h && (d(r = n.src.charCodeAt(i)) || 10 === r); i++) {
            ;
          } else l = "";
          (h <= i || 41 !== n.src.charCodeAt(i)) && (f = !0), i++;
        }

        if (f) {
          if (void 0 === n.env.references) return !1;
          if (i < h && 91 === n.src.charCodeAt(i) ? (p = i + 1, 0 <= (i = n.md.helpers.parseLinkLabel(n, i)) ? o = n.src.slice(p, i++) : i = b + 1) : i = b + 1, o = o || n.src.slice(g, b), !(s = n.env.references[c(o)])) return n.pos = m, !1;
          u = s.href, l = s.title;
        }

        return e || (n.pos = g, n.posMax = b, n.push("link_open", "a", 1).attrs = t = [["href", u]], l && t.push(["title", l]), n.md.inline.tokenize(n), n.push("link_close", "a", -1)), n.pos = i, n.posMax = h, !0;
      };
    }(n));
  }

  var Ve = (Ge.prototype.top = function () {
    return this.stack[this.stack.length - 1];
  }, Ge.prototype.push = function (n) {
    this.stack.length && this.top().content.push(n);
  }, Ge.prototype.addText = function (n) {
    if (n) {
      var e,
          t = this.top().content,
          r = t[t.length - 1],
          o = this.schema.text(n, this.marks);
      r && (e = function (n, e) {
        if (n.isText && e.isText && k.Mark.sameSet(n.marks, e.marks)) return n.copy(n.text + e.text);
      }(r, o)) ? t[t.length - 1] = e : t.push(o);
    }
  }, Ge.prototype.openMark = function (n) {
    this.marks = n.addToSet(this.marks);
  }, Ge.prototype.closeMark = function (n) {
    this.marks = n.removeFromSet(this.marks);
  }, Ge.prototype.parseTokens = function (n) {
    for (var e = 0; e < n.length; e++) {
      var t = n[e],
          r = this.tokenHandlers[t.type];
      if (!r) throw new Error("Token type `" + t.type + "` not supported by Markdown parser");
      r(this, t);
    }
  }, Ge.prototype.addNode = function (n, e, t) {
    var r = n.createAndFill(e, t, this.marks);
    return r ? (this.push(r), r) : null;
  }, Ge.prototype.openNode = function (n, e) {
    this.stack.push({
      type: n,
      attrs: e,
      content: []
    });
  }, Ge.prototype.closeNode = function () {
    this.marks.length && (this.marks = k.Mark.none);
    var n = this.stack.pop();
    if (n) return this.addNode(n.type, n.attrs, n.content);
  }, Ge);

  function Ge(n, e) {
    this.schema = n, this.stack = [{
      type: n.topNodeType,
      content: []
    }], this.marks = k.Mark.none, this.tokenHandlers = e;
  }

  function Ue(n, e) {
    return n.getAttrs ? n.getAttrs(e) : n.attrs instanceof Function ? n.attrs(e) : n.attrs;
  }

  function Ke(n) {
    return "code_inline" == n || "code_block" == n || "fence" == n;
  }

  function Ye(n) {
    return "\n" == n[n.length - 1] ? n.slice(0, n.length - 1) : n;
  }

  function Ze() {}

  var Qe = (Je.prototype.parse = function (n) {
    var e,
        t = new Ve(this.schema, this.tokenHandlers);

    for (t.parseTokens(this.tokenizer.parse(n, {})); e = t.closeNode(), t.stack.length;) {
      ;
    }

    return e;
  }, Je);

  function Je(n, e, t) {
    this.tokens = t, this.schema = n, this.tokenizer = e, this.tokenHandlers = function (e, a) {
      function n(n) {
        var t = a[n];

        if (t.block) {
          var r = e.nodeType(t.block);
          Ke(n) ? s[n] = function (n, e) {
            n.openNode(r, Ue(t, e)), n.addText(Ye(e.content)), n.closeNode();
          } : (s[n + "_open"] = function (n, e) {
            return n.openNode(r, Ue(t, e));
          }, s[n + "_close"] = function (n) {
            return n.closeNode();
          });
        } else if (t.node) {
          var o = e.nodeType(t.node);

          s[n] = function (n, e) {
            return n.addNode(o, Ue(t, e));
          };
        } else if (t.mark) {
          var i = e.marks[t.mark];
          Ke(n) ? s[n] = function (n, e) {
            n.openMark(i.create(Ue(t, e))), n.addText(Ye(e.content)), n.closeMark(i);
          } : (s[n + "_open"] = function (n, e) {
            return n.openMark(i.create(Ue(t, e)));
          }, s[n + "_close"] = function (n) {
            return n.closeMark(i);
          });
        } else {
          if (!t.ignore) throw new RangeError("Unrecognized parsing spec " + JSON.stringify(t));
          Ke(n) ? s[n] = Ze : (s[n + "_open"] = Ze, s[n + "_close"] = Ze);
        }
      }

      var s = Object.create(null);

      for (var t in a) {
        n(t);
      }

      return s.text = function (n, e) {
        return n.addText(e.content);
      }, s.inline = function (n, e) {
        return n.parseTokens(e.children);
      }, s.softbreak = function (n) {
        return n.addText("\n");
      }, s;
    }(n, t);
  }

  var Xe = require("markdown-it");

  function nt(n) {
    var e = Xe({
      html: !1
    });
    return e.use(je), e.use(We), new Qe(n, e, function (n) {
      var e = {};
      return n.nodes.blockquote && (e.blockquote = Pe.blockquote), n.nodes.paragraph && (e.paragraph = Pe.paragraph), n.nodes.list_item && (e.list_item = Pe.list_item), n.nodes.bullet_list && (e.bullet_list = Pe.bullet_list), n.nodes.ordered_list && (e.ordered_list = Pe.ordered_list), n.nodes.heading && (e.heading = Pe.heading), n.nodes.code_block && (e.code_block = Pe.code_block, e.fence = Pe.fence), n.nodes.horizontal_rule && (e.hr = Pe.hr), n.nodes.image && (e.image = Pe.image), n.nodes.hard_break && (e.hardbreak = Pe.hardbreak), n.nodes.ordered_list && (e.ordered_list = Pe.ordered_list), n.nodes.bullet_list && (e.bullet_list = Pe.bullet_list), n.nodes.list_item && (e.list_item = Pe.list_item), n.nodes.table && (e.table = Pe.table, e.thead = {
        ignore: !0
      }, e.th = Pe.table_header, e.tbody = {
        ignore: !0
      }, e.tr = Pe.table_row, e.td = Pe.table_cell), n.marks.em && (e.em = Pe.em), n.marks.strong && (e.strong = Pe.strong), n.marks.link && (e.link = Pe.link), n.marks.code && (e.code_inline = Pe.code_inline), n.marks.s && (e.s = Pe.s), e;
    }(n));
  }

  var et,
      tt = (C(rt, et = ze), rt.fromSchema = function (n) {
    return rt.commonMarkFromSchema(n);
  }, rt.commonMarkFromSchema = function (n) {
    var e = new rt(n);
    return e.parser = nt(n), e.serializer = Ne(n), e;
  }, rt.prototype.nodeFromString = function (n) {
    return this.parser.parse(n);
  }, rt.prototype.stringFromNode = function (n) {
    return this.serializer.serialize(n, {
      tightLists: !0
    });
  }, rt);

  function rt(n) {
    var e = et.call(this) || this;
    return e.parser = null, e.serializer = null, e.schema = n, e;
  }

  var ot,
      it = (C(at, ot = k.DOMSerializer), at.nodesFromSchema = function (n) {
    var e = st(n.nodes);
    return e.text || (e.text = function (n) {
      return n.text;
    }), e;
  }, at.marksFromSchema = function (n) {
    return st(n.marks);
  }, at);

  function at() {
    return null !== ot && ot.apply(this, arguments) || this;
  }

  function st(n) {
    var e = {};

    for (var t in n) {
      var r = n[t].spec.toDocument,
          o = n[t].spec.toDOM;
      r ? e[t] = r : o && (e[t] = o);
    }

    return e;
  }

  var lt,
      ct = (C(dt, lt = ze), dt.fromSchema = function (n) {
    return new dt(n);
  }, dt.prototype.nodeFromString = function (e) {
    var t;

    try {
      t = window.document.createRange().createContextualFragment(e);
    } catch (n) {
      t = new DOMParser().parseFromString(e, "text/html");
    }

    return this.parser.parse(t);
  }, dt.prototype.stringFromNode = function (n) {
    var e = document.createElement("div");
    return e.appendChild(this.serializer.serializeFragment(n.content)), e.innerHTML;
  }, dt);

  function dt(n) {
    var e = lt.call(this) || this;
    return e.schema = n, e.parser = k.DOMParser.fromSchema(n), e.serializer = it.fromSchema(n), e;
  }

  var ut = "undefined" == typeof navigator,
      pt = "undefined" != typeof navigator && /Mac/.test(navigator.platform),
      ft = null;
  ut || (ft = require("codemirror"));
  var mt = (ht.prototype.valueChanged = function () {
    var n = gt(this.node.textContent, this.cm.getValue());

    if (n) {
      var e = this.getPos() + 1,
          t = this.view.state.schema,
          r = this.view.state.tr.replaceWith(e + n.from, e + n.to, n.text ? t.text(n.text) : null);
      this.view.dispatch(r);
    }
  }, ht.prototype.asProseMirrorSelection = function (n) {
    var e = this.getPos() + 1,
        t = this.cm.indexFromPos(this.cm.getCursor("anchor")) + e,
        r = this.cm.indexFromPos(this.cm.getCursor("head")) + e;
    return N.TextSelection.create(n, t, r);
  }, ht.prototype.setSelection = function (n, e) {
    this.cm.focus(), this.updating = !0, this.cm.setSelection(this.cm.posFromIndex(n), this.cm.posFromIndex(e)), this.updating = !1;
  }, ht.prototype.setupCodeMirror = function (n) {
    return ft(null, {
      value: n.textContent,
      lineNumbers: !0,
      extraKeys: this.codeMirrorKeymap(),
      mode: n.attrs.params,
      theme: "forestry"
    });
  }, ht.prototype.codeMirrorKeymap = function () {
    var n,
        t = this,
        r = this.view,
        e = pt ? "Cmd" : "Ctrl";
    return ft.normalizeKeyMap(((n = {
      Up: function Up() {
        return t.maybeEscape("line", -1);
      },
      Left: function Left() {
        return t.maybeEscape("char", -1);
      },
      Down: function Down() {
        return t.maybeEscape("line", 1);
      },
      Right: function Right() {
        return t.maybeEscape("char", 1);
      },
      Backspace: function Backspace() {
        if (!function (a) {
          return function (n, e) {
            var t = a.getCursor(),
                r = a.getValue(),
                o = !r.replace(/[ \r\n]/g, "");
            if (0 != t.line || 0 != t.ch || !o) return !1;
            var i = n.selection.$from;
            return e && e(n.tr.replaceRangeWith(i.pos - 1, i.pos + r.length + 1, n.schema.nodes.paragraph.create()).setSelection(N.Selection.near(n.doc.resolve(i.pos - 1)))), !0;
          };
        }(t.cm)(t.view.state, t.view.dispatch)) return ft.Pass;
        t.view.focus();
      }
    })[e + "-Z"] = function () {
      return s.undo(r.state, r.dispatch);
    }, n["Shift-" + e + "-Z"] = function () {
      return s.redo(r.state, r.dispatch);
    }, n[e + "-Shift-Enter"] = function () {
      var n = t.cm.getCursor();
      if (t.cm.somethingSelected() || n.line != t.cm.firstLine()) return ft.Pass;

      if (r.state.selection.$anchor.parentOffset) {
        var e = r.state.selection.$anchor.pos;
        r.dispatch(r.state.tr.setSelection(N.Selection.near(t.view.state.doc.resolve(e - 1), -1)));
      }

      return function (n, e) {
        var t = n.selection,
            r = t.$head,
            o = t.$anchor;
        if (!r.parent.type.spec.code || !r.sameParent(o)) return !1;
        var i = r.node(-1),
            a = r.indexAfter(-1),
            s = i.defaultContentType(a);
        if (!i.canReplaceWith(a, a, s)) return !1;

        if (e) {
          var l = r.before(),
              c = n.tr.replaceWith(l, l, s.createAndFill());
          c.setSelection(N.Selection.near(c.doc.resolve(l), -1)), e(c.scrollIntoView());
        }

        return !0;
      }(r.state, r.dispatch) && r.focus(), !0;
    }, n["Shift-Enter"] = function () {
      var n = t.cm.getCursor();
      if (t.cm.somethingSelected() || n.line != t.cm.lastLine()) return ft.Pass;

      if (r.state.selection.$anchor.parentOffset) {
        var e = r.state.selection.$anchor.pos;
        r.dispatch(r.state.tr.setSelection(N.Selection.near(t.view.state.doc.resolve(e - 1), -1)));
      }

      return v.exitCode(r.state, r.dispatch) ? r.focus() : function (n, e) {
        var t = n.selection.$head,
            r = t.node(-1),
            o = t.indexAfter(-1),
            i = r.defaultContentType(o);

        if (e) {
          var a = t.before(),
              s = n.tr.replaceWith(a, a, i.createAndFill());
          s.setSelection(N.Selection.near(s.doc.resolve(a), 1)), e(s.scrollIntoView());
        }

        return !0;
      }(r.state, r.dispatch) ? r.focus() : void 0;
    }, n));
  }, ht.prototype.maybeEscape = function (n, e) {
    var t = this.cm.getCursor();
    if (this.cm.somethingSelected() || t.line != (e < 0 ? this.cm.firstLine() : this.cm.lastLine()) || "char" == n && t.ch != (e < 0 ? 0 : this.cm.getLine(t.line).length)) return ft.Pass;
    var r = this.getPos() + (e < 0 ? 0 : this.node.nodeSize),
        o = N.Selection.near(this.view.state.doc.resolve(r), e);
    if (!(o.$from.pos + 1 < this.view.state.doc.content.size)) return ft.Pass;
    this.view.dispatch(this.view.state.tr.setSelection(o)), this.view.focus();
  }, ht.prototype.update = function (n) {
    if (n.type != this.node.type) return !1;
    this.node = n;
    var e = gt(this.cm.getValue(), n.textContent);
    return e && (this.updating = !0, this.cm.replaceRange(e.text, this.cm.posFromIndex(e.from), this.cm.posFromIndex(e.to)), this.updating = !1), !0;
  }, ht.prototype.selectNode = function () {
    this.cm.focus();
  }, ht.prototype.stopEvent = function () {
    return !0;
  }, ht);

  function ht(n, e, t) {
    var r = this;
    this.node = n, this.view = e, this.getPos = t, this.updating = !1, this.onCursorActivity = function () {
      r.updating || r.forwardSelection();
    }, this.forwardSelection = function () {
      if (r.cm.hasFocus()) {
        var n = r.view.state,
            e = r.asProseMirrorSelection(n.doc);
        e.eq(n.selection) || r.view.dispatch(n.tr.setSelection(e));
      }
    }, this.onChange = function () {
      r.updating || r.valueChanged();
    }, ut || (this.cm = this.setupCodeMirror(n), this.dom = this.cm.getWrapperElement(), setTimeout(function () {
      return r.cm.refresh();
    }, 20), this.cm.on("cursorActivity", this.onCursorActivity), this.cm.on("changes", this.onChange), this.cm.on("focus", this.forwardSelection));
  }

  function gt(n, e) {
    if (n == e) return null;

    for (var t = 0, r = n.length, o = e.length; t < r && n.charCodeAt(t) == e.charCodeAt(t);) {
      ++t;
    }

    for (; t < r && t < o && n.charCodeAt(r - 1) == e.charCodeAt(o - 1);) {
      r--, o--;
    }

    return {
      from: t,
      to: r,
      text: e.slice(t, o)
    };
  }

  var bt = (vt.prototype.update = function (n) {
    if (this.img) {
      var e = n.attrs,
          t = e.alt,
          r = e.title;
      t && (this.img.alt = t), r && (this.img.title = r);
    }

    return !0;
  }, vt);

  function vt(n, e, t) {
    var r = this;
    this.selectNode = function () {
      r.img && (r.img.style.outline = "4px solid #0084FF", r.img.classList.add("tina-selected-image"));
    }, this.deselectNode = function () {
      r.img && (r.img.style.outline = "", r.img.classList.remove("tina-selected-image"));
    }, this.destroy = function () {
      r.deselectNode();
    }, this.node = n, this.view = e, this.getPos = t, this.dom = document.createElement("span"), this.dom.classList.add("tinacms-image-wrapper"), this.img = document.createElement("img");
    var o = n.attrs,
        i = o.src,
        a = o.align,
        s = o.alt,
        l = o.title,
        c = o.width,
        d = o.height;
    this.img.src = i, d && (this.img.style.height = d), c && (this.img.style.width = c), a && this.img.classList.add("align-" + a), s && (this.img.alt = s), l && (this.img.title = l), this.dom.appendChild(this.img);
  }

  var kt = {
    code_block: function code_block(n, e, t) {
      return new mt(n, e, t);
    },
    image: function image(n, e, t) {
      return new bt(n, e, t);
    }
  };

  function wt(r, e, t, n) {
    void 0 === e && (e = []);

    var o = function (n) {
      return [R.useMemo(function () {
        return new k.Schema({
          nodes: function (n) {
            var e = {};
            return n.filter(function (n) {
              return "wysiwyg:schema:node" === n.__type;
            }).forEach(function (n) {
              e[n.name] = n.node;
            }), e;
          }(n),
          marks: function (n) {
            var e = {};
            return n.filter(function (n) {
              return "wysiwyg:schema:mark" === n.__type;
            }).forEach(function (n) {
              e[n.name] = n.mark;
            }), e;
          }(n)
        });
      }, [n])];
    }(e)[0],
        i = function (n, e) {
      return void 0 === e && (e = "markdown"), [R.useMemo(function () {
        return "html" === e ? ct.fromSchema(n) : tt.fromSchema(n);
      }, [n])];
    }(o, n)[0],
        a = R.useState(),
        s = a[0],
        l = a[1],
        c = R.useCallback(function (n) {
      n !== s && l(n);
    }, []),
        d = R.useCallback(function (n) {
      return Ee(o, i, e, n, t);
    }, []),
        u = R.useState(),
        p = u[0],
        f = u[1];

    return R.useEffect(function () {
      if (s) {
        var t = new h.EditorView(s, {
          nodeViews: kt,
          state: d(r.value),
          dispatchTransaction: function dispatchTransaction(n) {
            var e = t.state.apply(n);
            t.updateState(e), f(t), n.docChanged && r.onChange(i.stringFromNode(n.doc));
          }
        });
        return f(t), function () {
          f(void 0), t && t.destroy();
        };
      }
    }, [s]), R.useEffect(function () {
      s && p && p.docView && (s.contains(document.activeElement) || p.updateState(d(r.value)));
    }, [r.value, p, document]), {
      elRef: c,
      editorView: p,
      translator: i
    };
  }

  var xt = {
    __type: "wysiwyg:schema:mark",
    name: "code",
    mark: {
      parseDOM: [{
        tag: "code"
      }],
      toDOM: function toDOM() {
        return ["code"];
      }
    }
  },
      yt = {
    __type: "wysiwyg:schema:mark",
    name: "link",
    mark: {
      attrs: {
        href: {},
        title: {
          "default": null
        },
        editing: {
          "default": null
        },
        creating: {
          "default": null
        }
      },
      inclusive: !1,
      parseDOM: [{
        tag: "a[href]",
        getAttrs: function getAttrs(n) {
          return {
            href: n.getAttribute("href"),
            title: n.getAttribute("title"),
            editing: n.getAttribute("editing"),
            creating: n.getAttribute("creating")
          };
        }
      }],
      toDOM: function toDOM(n) {
        return ["a", n.attrs];
      },
      toDocument: function toDocument(n) {
        var e = n.attrs;
        e.editing, e.creating;
        return ["a", _(e, ["editing", "creating"])];
      }
    }
  },
      Ct = {
    __type: "wysiwyg:schema:node",
    name: "doc",
    node: {
      content: "block+"
    }
  },
      _t = {
    __type: "wysiwyg:schema:node",
    name: "blockquote",
    node: {
      content: "block+",
      group: "block",
      defining: !0,
      parseDOM: [{
        tag: "blockquote"
      }],
      toDOM: function toDOM() {
        return ["blockquote", 0];
      }
    }
  },
      Mt = {
    __type: "wysiwyg:schema:node",
    name: "bullet_list",
    node: {
      content: "list_item+",
      group: "block",
      attrs: {
        tight: {
          "default": !1
        }
      },
      parseDOM: [{
        tag: "ul",
        getAttrs: function getAttrs(n) {
          return {
            tight: n.hasAttribute("data-tight")
          };
        }
      }],
      toDOM: function toDOM(n) {
        return ["ul", {
          "data-tight": n.attrs.tight ? "true" : null
        }, 0];
      }
    }
  },
      Et = {
    __type: "wysiwyg:schema:node",
    name: "code_block",
    node: {
      content: "text*",
      attrs: {
        params: {
          "default": ""
        }
      },
      group: "block",
      code: !0,
      defining: !0,
      parseDOM: [{
        tag: "pre",
        preserveWhitespace: "full"
      }],
      toDOM: function toDOM() {
        return ["pre", ["code", 0]];
      }
    }
  },
      zt = {
    __type: "wysiwyg:schema:node",
    name: "hard_break",
    node: {
      inline: !0,
      group: "inline",
      selectable: !1,
      parseDOM: [{
        tag: "br"
      }],
      toDOM: function toDOM() {
        return ["br"];
      }
    }
  };

  function At(n) {
    var e = {};

    for (var t in n) {
      n[t] && (e["forestry-" + t] = n[t]);
    }

    return e;
  }

  function St(n) {
    var e = {};

    for (var t in n) {
      n[t] && (e[t] = n[t]);
    }

    return e;
  }

  function Tt(e) {
    return function (n) {
      return _H(_H({}, e), Lt(n));
    };
  }

  function Lt(n) {
    for (var e = {}, t = n.attributes, r = 0; r < t.length; r++) {
      var o = t[r];
      if (o.value) e[o.name.startsWith("forestry-") ? o.name.slice(9) : o.name] = o.value;
    }

    return e;
  }

  var It = {
    __type: "wysiwyg:schema:node",
    name: "heading",
    node: {
      attrs: {
        level: {
          "default": 1
        },
        "class": {
          "default": ""
        },
        id: {
          "default": ""
        }
      },
      content: "inline*",
      marks: "_",
      group: "block",
      defining: !0,
      parseDOM: [{
        tag: "h1",
        getAttrs: Tt({
          level: 1
        })
      }, {
        tag: "h2",
        getAttrs: Tt({
          level: 2
        })
      }, {
        tag: "h3",
        getAttrs: Tt({
          level: 3
        })
      }, {
        tag: "h4",
        getAttrs: Tt({
          level: 4
        })
      }, {
        tag: "h5",
        getAttrs: Tt({
          level: 5
        })
      }, {
        tag: "h6",
        getAttrs: Tt({
          level: 6
        })
      }],
      toDocument: function toDocument(n) {
        var e = n.attrs;
        return ["h" + e.level, St(_(e, ["level"])), 0];
      },
      toDOM: function toDOM(n) {
        var e = n.attrs;
        return ["h" + e.level, At(_(e, ["level"])), 0];
      }
    }
  },
      Ft = {
    __type: "wysiwyg:schema:node",
    name: "horizontal_rule",
    node: {
      group: "block",
      allowGapCursor: !0,
      parseDOM: [{
        tag: "hr"
      }],
      toDOM: function toDOM() {
        return ["hr"];
      }
    }
  },
      Dt = {
    inline: !0,
    attrs: {
      src: {},
      align: {
        "default": null
      },
      alt: {
        "default": null
      },
      title: {
        "default": null
      },
      width: {
        "default": null
      },
      height: {
        "default": null
      }
    },
    group: "inline",
    draggable: !0,
    allowGapCursor: !0,
    parseDOM: [{
      tag: "img[src]",
      getAttrs: function getAttrs(n) {
        return {
          src: n.getAttribute("src"),
          title: n.getAttribute("title"),
          alt: n.getAttribute("alt"),
          align: function (n) {
            var e = n.getAttribute("class") || "",
                t = Bt.exec(e);
            if (t && 1 < t.length) return t[1];
            return null;
          }(n),
          width: n.getAttribute("width"),
          height: n.getAttribute("height")
        };
      }
    }],
    toDOM: function toDOM(n) {
      var e = {
        src: n.attrs.src
      };
      return n.attrs.title && (e.title = n.attrs.title), n.attrs.alt && (e.alt = n.attrs.alt), n.attrs.width && (e.width = n.attrs.width), n.attrs.height && (e.height = n.attrs.height), n.attrs.align && (e["class"] = "align-" + n.attrs.align), ["img", e];
    }
  },
      Bt = /align-([a-z]*)/;
  var Pt = {
    __type: "wysiwyg:schema:node",
    name: "image",
    node: Dt
  },
      Ot = {
    __type: "wysiwyg:schema:node",
    name: "list_item",
    node: {
      content: "paragraph block*",
      defining: !0,
      parseDOM: [{
        tag: "li"
      }],
      toDOM: function toDOM() {
        return ["li", 0];
      }
    }
  },
      Rt = {
    __type: "wysiwyg:schema:node",
    name: "ordered_list",
    node: {
      content: "list_item+",
      group: "block",
      attrs: {
        order: {
          "default": 1
        },
        tight: {
          "default": !1
        }
      },
      parseDOM: [{
        tag: "ol",
        getAttrs: function getAttrs(n) {
          return {
            order: n.hasAttribute("start") ? +(n.getAttribute("start") || 0) : 1,
            tight: n.hasAttribute("data-tight")
          };
        }
      }],
      toDOM: function toDOM(n) {
        return ["ol", {
          start: 1 == n.attrs.order ? null : n.attrs.order,
          "data-tight": n.attrs.tight ? "true" : null
        }, 0];
      }
    }
  },
      Nt = {
    __type: "wysiwyg:schema:node",
    name: "paragraph",
    node: {
      content: "inline*",
      marks: "_",
      attrs: {
        "class": {
          "default": ""
        },
        id: {
          "default": ""
        }
      },
      group: "block",
      parseDOM: [{
        tag: "p",
        getAttrs: Lt
      }],
      toDocument: function toDocument(n) {
        return ["p", St(n.attrs), 0];
      },
      toDOM: function toDOM(n) {
        return ["p", At(n.attrs), 0];
      }
    }
  },
      qt = {
    __type: "wysiwyg:schema:node",
    name: "text",
    node: {
      group: "inline"
    }
  },
      $t = b.tableNodes({
    tableGroup: "block",
    cellContent: "inline*",
    cellAttributes: {}
  });
  $t.table_cell = _H(_H({}, $t.table_cell), {
    marks: "_",
    attrs: _H(_H({}, $t.table_cell.attrs), {
      align: {
        "default": null
      }
    }),
    toDOM: function toDOM(n) {
      var e = {};
      return n.attrs.align && (e.style = "text-align: " + n.attrs.align + ";"), ["td", e, 0];
    }
  }), $t.table_header = _H(_H({}, $t.table_header), {
    marks: "_",
    attrs: _H(_H({}, $t.table_header.attrs), {
      align: {
        "default": null
      }
    }),
    toDOM: function toDOM(n) {
      var e = {};
      return n.attrs.align && (e.style = "text-align: " + n.attrs.align + ";"), ["th", e, 0];
    }
  });
  var Ht = Object.keys($t).map(function (n) {
    return {
      __type: "wysiwyg:schema:node",
      name: n,
      node: $t[n]
    };
  });

  function jt(n, e) {
    var t = function (n, e) {
      var t = n.selection,
          r = t.$from,
          o = t.$to,
          i;
      return r.blockRange(o, function (n) {
        return n.type == e;
      });
    }(n, n.schema.nodes.blockquote);

    if (!t) return !1;
    var r = c.liftTarget(t);
    return !!r && (e && e(n.tr.lift(t, r)), !0);
  }

  function Wt(n, e) {
    var t = o.liftListItem(n.schema.nodes.list_item);
    return o.wrapInList(n.schema.nodes.bullet_list)(n, e) || t(n, e);
  }

  function Vt(n, e) {
    var t = o.liftListItem(n.schema.nodes.list_item);
    return o.wrapInList(n.schema.nodes.ordered_list)(n, e) || t(n, e);
  }

  function Gt(n, e) {
    var t = n.selection.$cursor;
    if (!t) return !1;
    var r = n.doc.nodeAt(Math.max(t.pos - 1, 0));
    if (!r) return !1;
    if (r.type != n.schema.nodes.heading) return !1;
    if (r.textContent.length) return !1;

    if (e) {
      var o = n.tr;
      e(o.replaceRangeWith(t.pos - 1, t.pos + r.nodeSize - 1, n.schema.nodes.paragraph.create()).setSelection(new N.TextSelection(o.doc.resolve(n.selection.head))).scrollIntoView());
    }

    return !0;
  }

  function Ut(p, f, m, h) {
    return function (n, e) {
      var t = n.selection,
          r = t.from,
          o = t.to,
          i = null,
          a = -1;
      if (n.doc.nodesBetween(r, o, function (n, e) {
        return !i && (n.isTextblock && (i = n, a = e), !0);
      }), !i || a < 0) return !1;
      var s = n.doc.resolve(a),
          l = s.index(),
          c = n.selection.$head.parent.attrs.level == f.level,
          d = c ? m : p,
          u = c ? h : f;
      return !!s.parent.canReplaceWith(l, l + 1, d) && (e && e(n.tr.setBlockType(r, o, d, u).scrollIntoView()), !0);
    };
  }

  function Kt(n) {
    var t = n.nodes.hard_break;
    return v.chainCommands(v.exitCode, function (n, e) {
      return e(n.tr.replaceSelectionWith(t.create()).scrollIntoView()), !0;
    });
  }

  function Yt(e) {
    return function (n) {
      return Ut(n.nodes.heading, {
        level: e
      }, n.nodes.paragraph, null);
    };
  }

  var Zt = [{
    __type: "wysiwyg:keymap",
    name: "Mod-z",
    command: function command() {
      return s.undo;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Backspace",
    command: function command() {
      return d.undoInputRule;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Shift-z",
    command: function command() {
      return s.redo;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-y",
    command: function command() {
      return s.redo;
    },
    unlessMac: !0
  }, {
    __type: "wysiwyg:keymap",
    name: "Tab",
    command: function command() {
      return Jt;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Shift-Tab",
    command: function command() {
      return Xt;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-b",
    ifMark: "strong",
    command: function command(n) {
      return v.toggleMark(n.marks.strong);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-i",
    ifMark: "em",
    command: function command(n) {
      return v.toggleMark(n.marks.em);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-k",
    ifMark: "link",
    command: function command(n) {
      var t = v.toggleMark(n.marks.link, {
        href: "",
        title: "",
        creating: "creating",
        editing: "editing"
      });
      return function (n, e) {
        return !n.selection.$cursor && t(n, e);
      };
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Enter",
    command: Kt,
    ifNode: "hard_break"
  }, {
    __type: "wysiwyg:keymap",
    name: "Shift-Enter",
    command: Kt,
    ifNode: "hard_break"
  }, {
    __type: "wysiwyg:keymap",
    name: "Ctrl-Enter",
    command: Kt,
    ifNode: "hard_break",
    ifMac: !0
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-1",
    command: Yt(1),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-2",
    command: Yt(2),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-3",
    command: Yt(3),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-4",
    command: Yt(4),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-5",
    command: Yt(5),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-6",
    command: Yt(6),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Backspace",
    command: function command() {
      return Gt;
    },
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-7",
    command: function command() {
      return Vt;
    },
    ifNode: "ordered_list"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-8",
    command: function command() {
      return Wt;
    },
    ifNode: "bullet_list"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-9",
    command: function command(n) {
      return o.liftListItem(n.nodes.list_item);
    },
    onCondition: function onCondition(n) {
      return !(!n.nodes.bullet_list && !n.nodes.ordered_list);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-0",
    command: function command(n) {
      return v.setBlockType(n.nodes.code_block);
    },
    ifNode: "code_block"
  }, {
    __type: "wysiwyg:keymap",
    name: "ArrowLeft",
    command: function command() {
      return Qt("left");
    },
    ifNodes: ["code_block", "table"]
  }, {
    __type: "wysiwyg:keymap",
    name: "ArrowRight",
    command: function command() {
      return Qt("right");
    },
    ifNodes: ["code_block", "table"]
  }, {
    __type: "wysiwyg:keymap",
    name: "ArrowUp",
    command: function command() {
      return Qt("up");
    },
    ifNodes: ["code_block", "table"]
  }, {
    __type: "wysiwyg:keymap",
    name: "ArrowDown",
    command: function command() {
      return Qt("down");
    },
    ifNodes: ["code_block", "table"]
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-0",
    ifMark: "code",
    command: function command(n) {
      return v.toggleMark(n.marks.code);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod->",
    ifNode: "blockquote",
    command: function command(n) {
      return v.wrapIn(n.nodes.blockquote);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-<",
    ifNode: "blockquote",
    command: function command() {
      return jt;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-9",
    ifNode: "paragraph",
    command: function command(n) {
      return v.setBlockType(n.nodes.paragraph);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Shift-Ctrl-0",
    ifNode: "paragraph",
    command: function command(n) {
      return v.setBlockType(n.nodes.paragraph);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Enter",
    ifNode: "horizontal_rule",
    command: function command() {
      return ee;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Enter",
    ifNode: "list_item",
    command: function command(n) {
      return o.splitListItem(n.nodes.list_item);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Tab",
    ifNode: "list_item",
    command: function command(n) {
      return o.sinkListItem(n.nodes.list_item);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Shift-Tab",
    ifNode: "list_item",
    command: function command(n) {
      return o.liftListItem(n.nodes.list_item);
    }
  }];

  function Qt(s) {
    return function (n, e, t) {
      if (t.endOfTextblock(s)) {
        var r = "left" == s || "up" == s ? -1 : 1,
            o = n.selection.$head,
            i = N.Selection.near(n.doc.resolve(0 < r ? o.after() : o.before()), r);

        if (i.$head) {
          var a = i.$head.parent.type.name;
          if ("code_block" == a || "table_header" === a || "table_cell" === a) return e(n.tr.setSelection(i)), !0;
        }
      }

      return !1;
    };
  }

  var Jt = nr(1),
      Xt = nr(-1);

  function nr(r) {
    return function (n, e) {
      var t = n.schema.nodes.table;
      return !!x.findParentNodeOfType(t)(n.selection) && (b.goToNextCell(1 * r)(n, e), !0);
    };
  }

  var er,
      tr,
      rr = M([xt, {
    __type: "wysiwyg:schema:mark",
    name: "em",
    mark: {
      parseDOM: [{
        tag: "i"
      }, {
        tag: "em"
      }, {
        style: "font-style",
        getAttrs: function getAttrs(n) {
          return "italic" === n && null;
        }
      }],
      toDOM: function toDOM() {
        return ["em"];
      }
    }
  }, yt, {
    __type: "wysiwyg:schema:mark",
    name: "strong",
    mark: {
      parseDOM: [{
        tag: "strong"
      }, {
        tag: "b",
        getAttrs: function getAttrs(n) {
          return "normal" != n.style.fontWeight && null;
        }
      }, {
        style: "font-weight",
        getAttrs: function getAttrs(n) {
          return /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null;
        }
      }],
      toDOM: function toDOM() {
        return ["strong"];
      }
    }
  }], M([Ct, Nt, _t, Mt, Et, zt, It, Ft, Pt, Ot, Rt, qt], Ht), Zt),
      or = g.css(er = er || E(["\n  white-space: pre-wrap;\n\n  .CodeMirror {\n    font-family: monospace;\n    height: auto;\n    width: 100%;\n    border-radius: 5px;\n    margin-bottom: 16px;\n    color: black;\n    direction: ltr;\n  }\n\n  .CodeMirror-lines {\n    padding: 4px 0; /* Vertical padding around content */\n  }\n  .CodeMirror pre.CodeMirror-line,\n  .CodeMirror pre.CodeMirror-line-like {\n    padding: 0 4px; /* Horizontal padding of content */\n  }\n\n  .CodeMirror-scrollbar-filler,\n  .CodeMirror-gutter-filler {\n    background-color: white; /* The little square between H and V scrollbars */\n  }\n\n  /* GUTTER */\n\n  .CodeMirror-gutters {\n    border-right: 1px solid #ddd;\n    background-color: #f7f7f7;\n    white-space: nowrap;\n  }\n  .CodeMirror-linenumbers {\n  }\n  .CodeMirror-linenumber {\n    padding: 0 3px 0 5px;\n    min-width: 20px;\n    text-align: right;\n    color: #999;\n    white-space: nowrap;\n  }\n\n  .CodeMirror-guttermarker {\n    color: black;\n  }\n  .CodeMirror-guttermarker-subtle {\n    color: #999;\n  }\n\n  /* CURSOR */\n\n  .CodeMirror-cursor {\n    border-left: 1px solid black;\n    border-right: none;\n    width: 0;\n  }\n  /* Shown when moving in bi-directional text */\n  .CodeMirror div.CodeMirror-secondarycursor {\n    border-left: 1px solid silver;\n  }\n  .cm-fat-cursor .CodeMirror-cursor {\n    width: auto;\n    border: 0 !important;\n    background: #7e7;\n  }\n  .cm-fat-cursor div.CodeMirror-cursors {\n    z-index: 1;\n  }\n  .cm-fat-cursor-mark {\n    background-color: rgba(20, 255, 20, 0.5);\n    -webkit-animation: blink 1.06s steps(1) infinite;\n    -moz-animation: blink 1.06s steps(1) infinite;\n    animation: blink 1.06s steps(1) infinite;\n  }\n  .cm-animate-fat-cursor {\n    width: auto;\n    border: 0;\n    -webkit-animation: blink 1.06s steps(1) infinite;\n    -moz-animation: blink 1.06s steps(1) infinite;\n    animation: blink 1.06s steps(1) infinite;\n    background-color: #7e7;\n  }\n  @-moz-keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n  @-webkit-keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n  @keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n\n  /* Can style cursor different in overwrite (non-insert) mode */\n  .CodeMirror-overwrite .CodeMirror-cursor {\n  }\n\n  .cm-tab {\n    display: inline-block;\n    text-decoration: inherit;\n  }\n\n  .CodeMirror-rulers {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: -50px;\n    bottom: 0;\n    overflow: hidden;\n  }\n  .CodeMirror-ruler {\n    border-left: 1px solid #ccc;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n  }\n\n  /* DEFAULT THEME */\n\n  .cm-s-default .cm-header {\n    color: blue;\n  }\n  .cm-s-default .cm-quote {\n    color: #090;\n  }\n  .cm-negative {\n    color: #d44;\n  }\n  .cm-positive {\n    color: #292;\n  }\n  .cm-header,\n  .cm-strong {\n    font-weight: bold;\n  }\n  .cm-em {\n    font-style: italic;\n  }\n  .cm-link {\n    text-decoration: underline;\n  }\n  .cm-strikethrough {\n    text-decoration: line-through;\n  }\n\n  .cm-s-default .cm-keyword {\n    color: #708;\n  }\n  .cm-s-default .cm-atom {\n    color: #219;\n  }\n  .cm-s-default .cm-number {\n    color: #164;\n  }\n  .cm-s-default .cm-def {\n    color: #00f;\n  }\n  .cm-s-default .cm-variable,\n  .cm-s-default .cm-punctuation,\n  .cm-s-default .cm-property,\n  .cm-s-default .cm-operator {\n  }\n  .cm-s-default .cm-variable-2 {\n    color: #05a;\n  }\n  .cm-s-default .cm-variable-3,\n  .cm-s-default .cm-type {\n    color: #085;\n  }\n  .cm-s-default .cm-comment {\n    color: #a50;\n  }\n  .cm-s-default .cm-string {\n    color: #a11;\n  }\n  .cm-s-default .cm-string-2 {\n    color: #f50;\n  }\n  .cm-s-default .cm-meta {\n    color: #555;\n  }\n  .cm-s-default .cm-qualifier {\n    color: #555;\n  }\n  .cm-s-default .cm-builtin {\n    color: #30a;\n  }\n  .cm-s-default .cm-bracket {\n    color: #997;\n  }\n  .cm-s-default .cm-tag {\n    color: #170;\n  }\n  .cm-s-default .cm-attribute {\n    color: #00c;\n  }\n  .cm-s-default .cm-hr {\n    color: #999;\n  }\n  .cm-s-default .cm-link {\n    color: #00c;\n  }\n\n  .cm-s-default .cm-error {\n    color: #f00;\n  }\n  .cm-invalidchar {\n    color: #f00;\n  }\n\n  .CodeMirror-composing {\n    border-bottom: 2px solid;\n  }\n\n  /* Default styles for common addons */\n\n  div.CodeMirror span.CodeMirror-matchingbracket {\n    color: #0b0;\n  }\n  div.CodeMirror span.CodeMirror-nonmatchingbracket {\n    color: #a22;\n  }\n  .CodeMirror-matchingtag {\n    background: rgba(255, 150, 0, 0.3);\n  }\n  .CodeMirror-activeline-background {\n    background: #e8f2ff;\n  }\n\n  /* STOP */\n\n  /* The rest of this file contains styles related to the mechanics of\n    the editor. You probably shouldn't touch them. */\n\n  .CodeMirror {\n    position: relative;\n    overflow: hidden;\n    background: white;\n  }\n\n  .CodeMirror-scroll {\n    overflow: scroll !important; /* Things will break if this is overridden */\n    /* 30px is the magic margin used to hide the element's real scrollbars */\n    /* See overflow: hidden in .CodeMirror */\n    margin-bottom: -30px;\n    margin-right: -30px;\n    padding-bottom: 30px;\n    height: 100%;\n    outline: none; /* Prevent dragging from highlighting the element */\n    position: relative;\n  }\n  .CodeMirror-sizer {\n    position: relative;\n    min-height: auto;\n    border-right: 30px solid transparent;\n  }\n\n  /* The fake, visible scrollbars. Used to force redraw during scrolling\n    before actual scrolling happens, thus preventing shaking and\n    flickering artifacts. */\n  .CodeMirror-vscrollbar,\n  .CodeMirror-hscrollbar,\n  .CodeMirror-scrollbar-filler,\n  .CodeMirror-gutter-filler {\n    position: absolute;\n    z-index: 6;\n    display: none;\n  }\n  .CodeMirror-vscrollbar {\n    right: 0;\n    top: 0;\n    overflow-x: hidden;\n    overflow-y: scroll;\n  }\n  .CodeMirror-hscrollbar {\n    bottom: 0;\n    left: 0;\n    overflow-y: hidden;\n    overflow-x: scroll;\n  }\n  .CodeMirror-scrollbar-filler {\n    right: 0;\n    bottom: 0;\n  }\n  .CodeMirror-gutter-filler {\n    left: 0;\n    bottom: 0;\n  }\n\n  .CodeMirror-gutters {\n    position: absolute;\n    left: 0;\n    top: 0;\n    min-height: 100%;\n    z-index: 3;\n  }\n  .CodeMirror-gutter {\n    white-space: normal;\n    height: 100%;\n    display: inline-block;\n    vertical-align: top;\n    margin-bottom: -30px;\n  }\n  .CodeMirror-gutter-wrapper {\n    position: absolute;\n    z-index: 4;\n    background: none !important;\n    border: none !important;\n  }\n  .CodeMirror-gutter-background {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 4;\n  }\n  .CodeMirror-gutter-elt {\n    position: absolute;\n    cursor: default;\n    z-index: 4;\n  }\n  .CodeMirror-gutter-wrapper ::selection {\n    background-color: transparent;\n  }\n  .CodeMirror-gutter-wrapper ::-moz-selection {\n    background-color: transparent;\n  }\n\n  .CodeMirror-lines {\n    cursor: text;\n    min-height: 1px; /* prevents collapsing before first draw */\n  }\n  .CodeMirror pre.CodeMirror-line,\n  .CodeMirror pre.CodeMirror-line-like {\n    /* Reset some styles that the rest of the page might have set */\n    -moz-border-radius: 0;\n    -webkit-border-radius: 0;\n    border-radius: 0;\n    border-width: 0;\n    background: transparent;\n    font-family: inherit;\n    font-size: inherit;\n    margin: 0;\n    white-space: pre;\n    word-wrap: normal;\n    line-height: inherit;\n    color: inherit;\n    z-index: 2;\n    position: relative;\n    overflow: visible;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-font-variant-ligatures: contextual;\n    font-variant-ligatures: contextual;\n  }\n  .CodeMirror-wrap pre.CodeMirror-line,\n  .CodeMirror-wrap pre.CodeMirror-line-like {\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    word-break: normal;\n  }\n\n  .CodeMirror-linebackground {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n  }\n\n  .CodeMirror-linewidget {\n    position: relative;\n    z-index: 2;\n    padding: 0.1px; /* Force widget margins to stay inside of the container */\n  }\n\n  .CodeMirror-widget {\n  }\n\n  .CodeMirror-rtl pre {\n    direction: rtl;\n  }\n\n  .CodeMirror-code {\n    outline: none;\n  }\n\n  /* Force content-box sizing for the elements where we expect it */\n  .CodeMirror-scroll,\n  .CodeMirror-sizer,\n  .CodeMirror-gutter,\n  .CodeMirror-gutters,\n  .CodeMirror-linenumber {\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n  }\n\n  .CodeMirror-measure {\n    position: absolute;\n    width: 100%;\n    height: 0;\n    overflow: hidden;\n    visibility: hidden;\n  }\n\n  .CodeMirror-cursor {\n    position: absolute;\n    pointer-events: none;\n  }\n  .CodeMirror-measure pre {\n    position: static;\n  }\n\n  div.CodeMirror-cursors {\n    visibility: hidden;\n    position: relative;\n    z-index: 3;\n  }\n  div.CodeMirror-dragcursors {\n    visibility: visible;\n  }\n\n  .CodeMirror-focused div.CodeMirror-cursors {\n    visibility: visible;\n  }\n\n  .CodeMirror-selected {\n    background: #d9d9d9;\n  }\n  .CodeMirror-focused .CodeMirror-selected {\n    background: #d7d4f0;\n  }\n  .CodeMirror-crosshair {\n    cursor: crosshair;\n  }\n  .CodeMirror-line::selection,\n  .CodeMirror-line > span::selection,\n  .CodeMirror-line > span > span::selection {\n    background: #d7d4f0;\n  }\n  .CodeMirror-line::-moz-selection,\n  .CodeMirror-line > span::-moz-selection,\n  .CodeMirror-line > span > span::-moz-selection {\n    background: #d7d4f0;\n  }\n\n  .cm-searching {\n    background-color: #ffa;\n    background-color: rgba(255, 255, 0, 0.4);\n  }\n\n  /* Used to force a border model for a node */\n  .cm-force-border {\n    padding-right: 0.1px;\n  }\n\n  @media print {\n    /* Hide the cursor when printing */\n    .CodeMirror div.CodeMirror-cursors {\n      visibility: hidden;\n    }\n  }\n\n  /* See issue #2901 */\n  .cm-tab-wrap-hack:after {\n    content: '';\n  }\n\n  /* Help users use markselection to safely style text background */\n  span.CodeMirror-selectedtext {\n    background: none;\n  }\n"], ["\n  white-space: pre-wrap;\n\n  .CodeMirror {\n    font-family: monospace;\n    height: auto;\n    width: 100%;\n    border-radius: 5px;\n    margin-bottom: 16px;\n    color: black;\n    direction: ltr;\n  }\n\n  .CodeMirror-lines {\n    padding: 4px 0; /* Vertical padding around content */\n  }\n  .CodeMirror pre.CodeMirror-line,\n  .CodeMirror pre.CodeMirror-line-like {\n    padding: 0 4px; /* Horizontal padding of content */\n  }\n\n  .CodeMirror-scrollbar-filler,\n  .CodeMirror-gutter-filler {\n    background-color: white; /* The little square between H and V scrollbars */\n  }\n\n  /* GUTTER */\n\n  .CodeMirror-gutters {\n    border-right: 1px solid #ddd;\n    background-color: #f7f7f7;\n    white-space: nowrap;\n  }\n  .CodeMirror-linenumbers {\n  }\n  .CodeMirror-linenumber {\n    padding: 0 3px 0 5px;\n    min-width: 20px;\n    text-align: right;\n    color: #999;\n    white-space: nowrap;\n  }\n\n  .CodeMirror-guttermarker {\n    color: black;\n  }\n  .CodeMirror-guttermarker-subtle {\n    color: #999;\n  }\n\n  /* CURSOR */\n\n  .CodeMirror-cursor {\n    border-left: 1px solid black;\n    border-right: none;\n    width: 0;\n  }\n  /* Shown when moving in bi-directional text */\n  .CodeMirror div.CodeMirror-secondarycursor {\n    border-left: 1px solid silver;\n  }\n  .cm-fat-cursor .CodeMirror-cursor {\n    width: auto;\n    border: 0 !important;\n    background: #7e7;\n  }\n  .cm-fat-cursor div.CodeMirror-cursors {\n    z-index: 1;\n  }\n  .cm-fat-cursor-mark {\n    background-color: rgba(20, 255, 20, 0.5);\n    -webkit-animation: blink 1.06s steps(1) infinite;\n    -moz-animation: blink 1.06s steps(1) infinite;\n    animation: blink 1.06s steps(1) infinite;\n  }\n  .cm-animate-fat-cursor {\n    width: auto;\n    border: 0;\n    -webkit-animation: blink 1.06s steps(1) infinite;\n    -moz-animation: blink 1.06s steps(1) infinite;\n    animation: blink 1.06s steps(1) infinite;\n    background-color: #7e7;\n  }\n  @-moz-keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n  @-webkit-keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n  @keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n\n  /* Can style cursor different in overwrite (non-insert) mode */\n  .CodeMirror-overwrite .CodeMirror-cursor {\n  }\n\n  .cm-tab {\n    display: inline-block;\n    text-decoration: inherit;\n  }\n\n  .CodeMirror-rulers {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: -50px;\n    bottom: 0;\n    overflow: hidden;\n  }\n  .CodeMirror-ruler {\n    border-left: 1px solid #ccc;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n  }\n\n  /* DEFAULT THEME */\n\n  .cm-s-default .cm-header {\n    color: blue;\n  }\n  .cm-s-default .cm-quote {\n    color: #090;\n  }\n  .cm-negative {\n    color: #d44;\n  }\n  .cm-positive {\n    color: #292;\n  }\n  .cm-header,\n  .cm-strong {\n    font-weight: bold;\n  }\n  .cm-em {\n    font-style: italic;\n  }\n  .cm-link {\n    text-decoration: underline;\n  }\n  .cm-strikethrough {\n    text-decoration: line-through;\n  }\n\n  .cm-s-default .cm-keyword {\n    color: #708;\n  }\n  .cm-s-default .cm-atom {\n    color: #219;\n  }\n  .cm-s-default .cm-number {\n    color: #164;\n  }\n  .cm-s-default .cm-def {\n    color: #00f;\n  }\n  .cm-s-default .cm-variable,\n  .cm-s-default .cm-punctuation,\n  .cm-s-default .cm-property,\n  .cm-s-default .cm-operator {\n  }\n  .cm-s-default .cm-variable-2 {\n    color: #05a;\n  }\n  .cm-s-default .cm-variable-3,\n  .cm-s-default .cm-type {\n    color: #085;\n  }\n  .cm-s-default .cm-comment {\n    color: #a50;\n  }\n  .cm-s-default .cm-string {\n    color: #a11;\n  }\n  .cm-s-default .cm-string-2 {\n    color: #f50;\n  }\n  .cm-s-default .cm-meta {\n    color: #555;\n  }\n  .cm-s-default .cm-qualifier {\n    color: #555;\n  }\n  .cm-s-default .cm-builtin {\n    color: #30a;\n  }\n  .cm-s-default .cm-bracket {\n    color: #997;\n  }\n  .cm-s-default .cm-tag {\n    color: #170;\n  }\n  .cm-s-default .cm-attribute {\n    color: #00c;\n  }\n  .cm-s-default .cm-hr {\n    color: #999;\n  }\n  .cm-s-default .cm-link {\n    color: #00c;\n  }\n\n  .cm-s-default .cm-error {\n    color: #f00;\n  }\n  .cm-invalidchar {\n    color: #f00;\n  }\n\n  .CodeMirror-composing {\n    border-bottom: 2px solid;\n  }\n\n  /* Default styles for common addons */\n\n  div.CodeMirror span.CodeMirror-matchingbracket {\n    color: #0b0;\n  }\n  div.CodeMirror span.CodeMirror-nonmatchingbracket {\n    color: #a22;\n  }\n  .CodeMirror-matchingtag {\n    background: rgba(255, 150, 0, 0.3);\n  }\n  .CodeMirror-activeline-background {\n    background: #e8f2ff;\n  }\n\n  /* STOP */\n\n  /* The rest of this file contains styles related to the mechanics of\n    the editor. You probably shouldn't touch them. */\n\n  .CodeMirror {\n    position: relative;\n    overflow: hidden;\n    background: white;\n  }\n\n  .CodeMirror-scroll {\n    overflow: scroll !important; /* Things will break if this is overridden */\n    /* 30px is the magic margin used to hide the element's real scrollbars */\n    /* See overflow: hidden in .CodeMirror */\n    margin-bottom: -30px;\n    margin-right: -30px;\n    padding-bottom: 30px;\n    height: 100%;\n    outline: none; /* Prevent dragging from highlighting the element */\n    position: relative;\n  }\n  .CodeMirror-sizer {\n    position: relative;\n    min-height: auto;\n    border-right: 30px solid transparent;\n  }\n\n  /* The fake, visible scrollbars. Used to force redraw during scrolling\n    before actual scrolling happens, thus preventing shaking and\n    flickering artifacts. */\n  .CodeMirror-vscrollbar,\n  .CodeMirror-hscrollbar,\n  .CodeMirror-scrollbar-filler,\n  .CodeMirror-gutter-filler {\n    position: absolute;\n    z-index: 6;\n    display: none;\n  }\n  .CodeMirror-vscrollbar {\n    right: 0;\n    top: 0;\n    overflow-x: hidden;\n    overflow-y: scroll;\n  }\n  .CodeMirror-hscrollbar {\n    bottom: 0;\n    left: 0;\n    overflow-y: hidden;\n    overflow-x: scroll;\n  }\n  .CodeMirror-scrollbar-filler {\n    right: 0;\n    bottom: 0;\n  }\n  .CodeMirror-gutter-filler {\n    left: 0;\n    bottom: 0;\n  }\n\n  .CodeMirror-gutters {\n    position: absolute;\n    left: 0;\n    top: 0;\n    min-height: 100%;\n    z-index: 3;\n  }\n  .CodeMirror-gutter {\n    white-space: normal;\n    height: 100%;\n    display: inline-block;\n    vertical-align: top;\n    margin-bottom: -30px;\n  }\n  .CodeMirror-gutter-wrapper {\n    position: absolute;\n    z-index: 4;\n    background: none !important;\n    border: none !important;\n  }\n  .CodeMirror-gutter-background {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 4;\n  }\n  .CodeMirror-gutter-elt {\n    position: absolute;\n    cursor: default;\n    z-index: 4;\n  }\n  .CodeMirror-gutter-wrapper ::selection {\n    background-color: transparent;\n  }\n  .CodeMirror-gutter-wrapper ::-moz-selection {\n    background-color: transparent;\n  }\n\n  .CodeMirror-lines {\n    cursor: text;\n    min-height: 1px; /* prevents collapsing before first draw */\n  }\n  .CodeMirror pre.CodeMirror-line,\n  .CodeMirror pre.CodeMirror-line-like {\n    /* Reset some styles that the rest of the page might have set */\n    -moz-border-radius: 0;\n    -webkit-border-radius: 0;\n    border-radius: 0;\n    border-width: 0;\n    background: transparent;\n    font-family: inherit;\n    font-size: inherit;\n    margin: 0;\n    white-space: pre;\n    word-wrap: normal;\n    line-height: inherit;\n    color: inherit;\n    z-index: 2;\n    position: relative;\n    overflow: visible;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-font-variant-ligatures: contextual;\n    font-variant-ligatures: contextual;\n  }\n  .CodeMirror-wrap pre.CodeMirror-line,\n  .CodeMirror-wrap pre.CodeMirror-line-like {\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    word-break: normal;\n  }\n\n  .CodeMirror-linebackground {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n  }\n\n  .CodeMirror-linewidget {\n    position: relative;\n    z-index: 2;\n    padding: 0.1px; /* Force widget margins to stay inside of the container */\n  }\n\n  .CodeMirror-widget {\n  }\n\n  .CodeMirror-rtl pre {\n    direction: rtl;\n  }\n\n  .CodeMirror-code {\n    outline: none;\n  }\n\n  /* Force content-box sizing for the elements where we expect it */\n  .CodeMirror-scroll,\n  .CodeMirror-sizer,\n  .CodeMirror-gutter,\n  .CodeMirror-gutters,\n  .CodeMirror-linenumber {\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n  }\n\n  .CodeMirror-measure {\n    position: absolute;\n    width: 100%;\n    height: 0;\n    overflow: hidden;\n    visibility: hidden;\n  }\n\n  .CodeMirror-cursor {\n    position: absolute;\n    pointer-events: none;\n  }\n  .CodeMirror-measure pre {\n    position: static;\n  }\n\n  div.CodeMirror-cursors {\n    visibility: hidden;\n    position: relative;\n    z-index: 3;\n  }\n  div.CodeMirror-dragcursors {\n    visibility: visible;\n  }\n\n  .CodeMirror-focused div.CodeMirror-cursors {\n    visibility: visible;\n  }\n\n  .CodeMirror-selected {\n    background: #d9d9d9;\n  }\n  .CodeMirror-focused .CodeMirror-selected {\n    background: #d7d4f0;\n  }\n  .CodeMirror-crosshair {\n    cursor: crosshair;\n  }\n  .CodeMirror-line::selection,\n  .CodeMirror-line > span::selection,\n  .CodeMirror-line > span > span::selection {\n    background: #d7d4f0;\n  }\n  .CodeMirror-line::-moz-selection,\n  .CodeMirror-line > span::-moz-selection,\n  .CodeMirror-line > span > span::-moz-selection {\n    background: #d7d4f0;\n  }\n\n  .cm-searching {\n    background-color: #ffa;\n    background-color: rgba(255, 255, 0, 0.4);\n  }\n\n  /* Used to force a border model for a node */\n  .cm-force-border {\n    padding-right: 0.1px;\n  }\n\n  @media print {\n    /* Hide the cursor when printing */\n    .CodeMirror div.CodeMirror-cursors {\n      visibility: hidden;\n    }\n  }\n\n  /* See issue #2901 */\n  .cm-tab-wrap-hack:after {\n    content: '';\n  }\n\n  /* Help users use markselection to safely style text background */\n  span.CodeMirror-selectedtext {\n    background: none;\n  }\n"])),
      ir = g.css(tr = tr || E(["\n  .ProseMirror .tinacms-image-wrapper {\n    display: inline-block;\n    margin: 1em 0;\n  }\n\n  ", "\n"], ["\n  .ProseMirror .tinacms-image-wrapper {\n    display: inline-block;\n    margin: 1em 0;\n  }\n\n  ", "\n"]), "\n  .ProseMirror .tableWrapper {\n    overflow-x: auto;\n  }\n  .ProseMirror .column-resize-handle {\n    position: absolute;\n    right: -2px;\n    top: 0;\n    bottom: 0;\n    width: 4px;\n    z-index: 20;\n    background-color: #adf;\n    pointer-events: none;\n  }\n  .ProseMirror.resize-cursor {\n    cursor: ew-resize;\n    cursor: col-resize;\n  }\n  /* Give selected cells a blue overlay */\n  .ProseMirror .selectedCell:after {\n    z-index: 2;\n    position: absolute;\n    content: '';\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(0, 132, 255, 0.25);\n    /* This provides a bullet-proof border for selected cells even with border collapsing */\n    box-shadow: 0 0 0 1px #0574E4;\n    pointer-events: none;\n  }\n  .ProseMirror:focus {\n    outline: 0px solid transparent;\n  }\n  .ProseMirror table {\n    border-collapse: collapse;\n    table-layout: fixed;\n    display: inline-table;\n    margin: 32px 0 32px 0;\n    overflow: visible;\n    width: 100%;\n  }\n  .ProseMirror th {\n    background-color: #F6F6F9;\n  }\n  .ProseMirror table td,\n  .ProseMirror table th {\n    border: 1px solid #E1DDEC;\n    padding: 6px 8px;\n    position: relative;\n    vertical-align: top;\n    box-sizing: border-box;\n  }\n  .ProseMirror .tina_table_header_ext_top {\n    background: #F6F6F9;\n    border: 1px solid #E1DDEC;\n    position: absolute;\n    height: 12px;\n    width: calc(100% + 2px);\n    transform: translate(-9px, -18px);\n    cursor: pointer;\n    z-index: 1;\n    user-select: none;\n  }\n  .ProseMirror div.tina_table_header_ext_top_selected {\n    background: #0084ff;\n    border-color: #0574E4;\n    z-index: 10;\n  }\n  .ProseMirror .tina_table_header_ext_left {\n    background: #F6F6F9;\n    border: 1px solid #E1DDEC;\n    position: absolute;\n    height: calc(100% + 2px);\n    width: 12px;\n    transform: translate(-20px, -7px);\n    cursor: pointer;\n    z-index: 1;\n    user-select: none;\n  }\n  .ProseMirror div.tina_table_header_ext_left_selected {\n    background: #0084ff;\n    border-color: #0574E4;\n    z-index: 10;\n  }\n  .ProseMirror .tina_table_header_ext_top_left {\n    background: #F6F6F9;\n    border: 1px solid #E1DDEC;\n    position: absolute;\n    height: 12px;\n    width: 12px;\n    transform: translate(-20px, -18px);\n    border-radius: 5px 0 0 0;\n    z-index: 1;\n    cursor: pointer;\n    user-select: none;\n  }\n  .ProseMirror div.tina_table_header_ext_top_left_selected {\n    background: #0084ff;\n    border-color: #0574E4;\n    z-index: 10;\n  }\n  .ProseMirror .selectedCell {\n    border-color: transparent;\n  }\n");

  function ar(n) {
    var e,
        t,
        r = n.mark,
        o = n.Icon,
        i = n.tooltip,
        a = n.defaultAttrs,
        s = n.selectionOnly,
        l = void 0 !== s && s,
        c = n.noMix,
        d = void 0 === c ? [] : c,
        u = n.isDisabled;
    return C(p, t = R.Component), p.prototype.markType = function (n) {
      return this.props.view.state.schema.marks[n];
    }, Object.defineProperty(p.prototype, "active", {
      get: function get() {
        return this.markIsActive(r);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(p.prototype, "disabled", {
      get: function get() {
        return u ? u(this.props.view) : "image" === r && l ? !!this.props.view.state.selection.$cursor || this.inCodeBlock || this.incompatibleMarksAreActive : this.inCodeBlock || this.incompatibleMarksAreActive;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(p.prototype, "inCodeBlock", {
      get: function get() {
        var n = this.props.view;
        return n.state.selection.$from.node(n.state.selection.$from.depth).type === n.state.schema.nodes.code_block;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(p.prototype, "incompatibleMarksAreActive", {
      get: function get() {
        return d.map(this.markIsActive).reduce(function (n, e) {
          return e || n;
        }, !1);
      },
      enumerable: !0,
      configurable: !0
    }), p.prototype.render = function () {
      return this.markType(r) ? R.createElement(pi, {
        "data-tooltip": i,
        "data-side": "top",
        onClick: this.onClick,
        active: this.active,
        disabled: this.disabled
      }, R.createElement(o, null)) : null;
    }, (e = p).displayName = r + "Control", e;

    function p() {
      var s = null !== t && t.apply(this, arguments) || this;
      return s.markIsActive = function (n) {
        var e = s.props.view.state,
            t = s.markType(n),
            r = e.selection,
            o = r.from,
            i = r.$from,
            a = r.to;
        return r.empty ? !!t.isInSet(e.storedMarks || i.marks()) : e.doc.rangeHasMark(o, a, t);
      }, s.onClick = function () {
        if (!s.disabled) {
          var n = s.props.view,
              e = n.state,
              t = n.dispatch;
          e.selection.$cursor && l || v.toggleMark(s.markType(r), a)(e, t);
        }
      }, s;
    }
  }

  function sr(n) {
    var e,
        t = n.Component,
        r = n.children,
        o = n.command,
        i = n.typeName,
        a = n.attrs;
    return C(s, e = R.Component), Object.defineProperty(s.prototype, "active", {
      get: function get() {
        if (!i) return !1;
        var n = this.props.view.state.selection.$from,
            e = n.node(n.depth),
            t = e.type.name === i,
            r = !a || e.attrs.level === a.level;
        return t && r;
      },
      enumerable: !0,
      configurable: !0
    }), s.prototype.render = function () {
      return R.createElement(gi, {
        onClick: this.onClick,
        disabled: !this.canDo(),
        active: this.active
      }, R.createElement(t, null, r));
    }, s;

    function s() {
      var n = null !== e && e.apply(this, arguments) || this;
      return n.canDo = function () {
        return o(n.props.view.state);
      }, n.onClick = function () {
        o(n.props.view.state, n.props.view.dispatch), n.props.view.focus(), n.props.onClick();
      }, n;
    }
  }

  var lr,
      cr = (C(dr, lr = R.Component), dr.prototype.render = function () {
    var n = this,
        e = this.props.view;
    return R.createElement(fi, null, R.createElement(pi, {
      ref: this.menuButtonRef,
      "data-tooltip": "Heading",
      onClick: this.toggle,
      active: this.state.active
    }, R.createElement(m.HeadingIcon, null)), R.createElement(mi, {
      triggerRef: this.menuButtonRef,
      open: this.state.active
    }, R.createElement(f.Dismissible, {
      click: !0,
      escape: !0,
      disabled: !this.state.active,
      onDismiss: function onDismiss() {
        n.toggle();
      }
    }, R.createElement(to, {
      view: e,
      onClick: this.toggle
    }), R.createElement(ro, {
      view: e,
      onClick: this.toggle
    }), R.createElement(oo, {
      view: e,
      onClick: this.toggle
    }), R.createElement(io, {
      view: e,
      onClick: this.toggle
    }), R.createElement(ao, {
      view: e,
      onClick: this.toggle
    }), R.createElement(so, {
      view: e,
      onClick: this.toggle
    }))));
  }, dr);

  function dr() {
    var n = null !== lr && lr.apply(this, arguments) || this;
    return n.state = {
      active: !1
    }, n.menuButtonRef = R.createRef(), n.toggle = function () {
      return n.setState(function (n) {
        return {
          active: !n.active
        };
      });
    }, n.blockQuote = function () {
      return v.wrapIn(n.props.view.state.schema.nodes.blockquote)(n.props.view.state, n.props.view.dispatch);
    }, n.lift = function () {
      return v.lift(n.props.view.state, n.props.view.dispatch);
    }, n;
  }

  function ur(t) {
    return function (n, e) {
      return Ut(n.schema.nodes.heading, {
        level: t
      }, n.schema.nodes.paragraph, null)(n, e);
    };
  }

  function pr(n, e) {
    var t = n.state,
        r = n.dispatch,
        o = t.selection,
        i = t.schema.nodes,
        a = i.table,
        s = i.table_cell,
        l = i.table_header,
        c = x.findParentNodeOfType(s)(t.selection),
        d = x.findParentNodeOfType(l)(t.selection),
        u = c || d;

    if (u) {
      var p = u.node.attrs.align === e ? void 0 : e,
          f = x.findParentNodeOfType(a)(t.selection);

      if (f) {
        var m = b.TableMap.get(f.node),
            h = Object.entries(m.map).find(function (n) {
          return n[1] > o.head - f.start;
        });

        if (h) {
          var g = (parseInt(h[0]) - 1) % m.width;
          r(x.forEachCellInColumn(g, function (n, e) {
            return x.setCellAttrs(n, {
              align: p
            })(e);
          })(t.tr)), n.focus();
        }
      }
    }
  }

  function fr(n) {
    var e = n.view,
        t = e.state,
        r = e.dispatch;
    if (document.getElementsByClassName("tina_table_header_ext_top_left_selected")[0]) return null;

    for (var o, i = document.getElementsByClassName("tina_table_header_ext_top_selected")[0], a = document.getElementsByClassName("tina_table_header_ext_left"), s = 1; s < a.length; s++) {
      a[s].classList.contains("tina_table_header_ext_left_selected") && (o = a[s]);
    }

    return i || o ? R.createElement(R.Fragment, null, i && w.createPortal(R.createElement(lo, null, R.createElement(O.IconButton, {
      onClick: function onClick() {
        return pr(n.view, "left");
      },
      small: !0,
      primary: !0
    }, R.createElement(m.AlignLeft, null)), R.createElement(O.IconButton, {
      onClick: function onClick() {
        return pr(n.view, "center");
      },
      small: !0,
      primary: !0
    }, R.createElement(m.AlignCenter, null)), R.createElement(O.IconButton, {
      onClick: function onClick() {
        return pr(n.view, "right");
      },
      small: !0,
      primary: !0
    }, R.createElement(m.AlignRight, null)), R.createElement(O.IconButton, {
      onClick: function onClick() {
        b.deleteColumn(t, r), n.view.focus();
      },
      small: !0,
      primary: !0
    }, R.createElement(m.TrashIcon, null))), i), o && w.createPortal(R.createElement(co, null, R.createElement(O.IconButton, {
      onClick: function onClick() {
        b.deleteRow(t, r), n.view.focus();
      },
      small: !0,
      primary: !0
    }, R.createElement(m.TrashIcon, null))), o)) : null;
  }

  function mr(n) {
    var e = n.index,
        t = n.marker,
        r = n.tableHeight,
        o = n.view,
        i = o.state,
        a = o.dispatch,
        s = R.useState(!1),
        l = s[0],
        c = s[1];
    return R.useEffect(function () {
      t.style.zIndex = l ? "1000" : "1";
    }, [l]), w.createPortal($.createElement($.Fragment, null, $.createElement(uo, {
      onMouseEnter: function onMouseEnter() {
        return c(!0);
      },
      onMouseLeave: function onMouseLeave() {
        return c(!1);
      }
    }, l ? $.createElement(fo, null, $.createElement(O.IconButton, {
      onClick: function onClick() {
        !function (n) {
          a(x.addColumnAt(n)(i.tr)), o.focus();
        }(e), c(!1);
      },
      small: !0,
      primary: !0
    }, $.createElement(m.AddIcon, null))) : $.createElement(po, null)), l && $.createElement(mo, {
      height: r
    })), t);
  }

  function hr(n) {
    var e = n.index,
        t = n.marker,
        r = n.tableWidth,
        d = n.view,
        u = d.state,
        p = d.dispatch,
        o = R.useState(!1),
        i = o[0],
        a = o[1];
    return R.useEffect(function () {
      t.style.zIndex = i ? "1000" : "1";
    }, [i]), w.createPortal($.createElement($.Fragment, null, $.createElement(ho, {
      onMouseEnter: function onMouseEnter() {
        return a(!0);
      },
      onMouseLeave: function onMouseLeave() {
        return a(!1);
      }
    }, i && 0 < e ? $.createElement(bo, null, $.createElement(O.IconButton, {
      onClick: function onClick() {
        return function (n) {
          if (1 < n) p(x.addRowAt(n, !0)(u.tr));else {
            var e = u.schema.nodes,
                t = e.table,
                r = e.table_cell,
                o = e.table_row,
                i = x.findParentNodeOfType(t)(u.selection);
            if (!i) return;
            var a = b.TableMap.get(i.node),
                s = i.start + a.map[a.width] - 1,
                l = x.getCellsInRow(0)(u.selection);
            if (!l) return;
            var c = null == l ? void 0 : l.map(function (n) {
              return r.createAndFill(_H({}, n.node.attrs));
            });
            p(u.tr.insert(s, o.create(null, c)));
          }
          d.focus();
        }(e);
      },
      small: !0,
      primary: !0
    }, $.createElement(m.AddIcon, null))) : $.createElement(go, null)), i && $.createElement(vo, {
      width: r
    })), t);
  }

  function gr(n) {
    var t = n.view,
        e = document.getElementsByClassName("tina_table_header_ext_top_left");
    if (!e.length) return null;
    var r = e[0].closest("table");
    if (!r) return null;

    for (var o = r.getBoundingClientRect(), i = o.height, a = o.width, s = document.getElementsByClassName("tina_table_header_ext_top"), l = [e[0]], c = 0; c < s.length; c++) {
      l.push(s[c]);
    }

    var d = document.getElementsByClassName("tina_table_header_ext_left"),
        u = [e[0]];

    for (c = 0; c < d.length; c++) {
      u.push(d[c]);
    }

    return $.createElement($.Fragment, null, l.map(function (n, e) {
      return $.createElement(mr, {
        key: "add-column-menu-" + e,
        index: e,
        marker: n,
        tableHeight: i,
        view: t
      });
    }), u.map(function (n, e) {
      return $.createElement(hr, {
        key: "add-row-menu-" + e,
        index: e,
        marker: n,
        tableWidth: a,
        view: t
      });
    }));
  }

  function br(n) {
    var t = n.view,
        e = document.getElementsByClassName("tina_table_header_ext_top_left");
    if (!e.length) return null;
    var r = e[0].closest("table");
    if (!r) return null;
    var o = r.getBoundingClientRect(),
        i = o.height,
        a = o.width;
    return p.createPortal($.createElement(ko, {
      height: i,
      width: a
    }, $.createElement(O.IconButton, {
      onClick: function onClick() {
        var n = t.state,
            e = t.dispatch;
        b.deleteTable(n, e), t.focus();
      },
      small: !0,
      primary: !0
    }, $.createElement(m.TrashIcon, null))), e[0]);
  }

  function vr(n) {
    return R.createElement(R.Fragment, null, R.createElement(fr, _H({}, n)), R.createElement(gr, _H({}, n)), R.createElement(br, _H({}, n)));
  }

  function kr(n) {
    var i = n.view,
        e = _e.getState(i.state).selectedImage;

    if (!e) return null;
    var a = e.node,
        s = e.pos,
        t = i.state.schema.marks.link,
        r = a.marks.find(function (n) {
      return n.type === t;
    }),
        o = R.useState(a.attrs.title),
        l = o[0],
        c = o[1],
        d = R.useState(a.attrs.alt),
        u = d[0],
        p = d[1],
        f = R.useState(r && r.attrs.title),
        m = f[0],
        h = f[1],
        g = R.useState(r && r.attrs.href),
        b = g[0],
        v = g[1],
        k = i.coordsAtPos(s),
        w = k.top,
        x = k.left,
        y = R.useState(w),
        C = y[0],
        _ = y[1],
        M = R.useState(x),
        E = M[0],
        z = M[1],
        A = R.useRef(),
        S = R.useRef(),
        T = R.useRef(),
        L = R.useState(!!r),
        I = L[0],
        F = L[1];

    function D(n) {
      var e = document.getElementsByClassName("tina-selected-image")[0];

      if (e && (T.current !== e || n) && A.current) {
        T.current = e;
        var t = A.current.getBoundingClientRect();
        z(e.clientWidth / 2 + re(e) - t.width / 2), _(te(e));
      }
    }

    function B() {
      var n = i.dispatch,
          e = i.state,
          t = e.schema.nodes.image,
          r = e.schema.marks.link,
          o = e.tr;
      I && (b || m) ? o.addMark(s, s + 1, r.create({
        href: b,
        title: m
      })) : o.removeMark(s, s + 1, r), o.setNodeMarkup(s, t, _H(_H({}, a.attrs), {
        alt: u,
        title: l
      })).setSelection(new N.NodeSelection(o.doc.resolve(s))), n(o), P();
    }

    R.useEffect(function () {
      var n = q(function () {
        return D(!0);
      }, 10);
      return window.addEventListener("scroll", n), function () {
        window.removeEventListener("scroll", n);
      };
    }), R.useEffect(function () {
      h(r ? r.attrs.title : ""), v(r ? r.attrs.href : ""), F(!!r);
    }, [r]), R.useEffect(function () {
      c(a.attrs.title), p(a.attrs.alt);
    }, [e.node]), R.useEffect(function () {
      setTimeout(function () {
        S.current && S.current.focus();
      });
    }, [S]), R.useEffect(D);

    var P = function P() {
      (0, i.dispatch)(i.state.tr.setMeta("image_clicked", !1)), c(""), p(""), h(""), v("");
    };

    return $.createElement(O.TinaReset, null, $.createElement(wo, {
      top: C,
      left: E,
      ref: A,
      onKeyDown: function onKeyDown(n) {
        "Escape" === n.key && P(), "Enter" === n.key && B();
      }
    }, $.createElement(xo, null, "Title"), $.createElement(yo, {
      placeholder: "Enter Title",
      type: "text",
      ref: S,
      value: l,
      onChange: function onChange(n) {
        return c(n.target.value);
      }
    }), $.createElement(xo, null, "Alt"), $.createElement(yo, {
      placeholder: "Enter Alt Text",
      type: "text",
      value: u,
      onChange: function onChange(n) {
        return p(n.target.value);
      }
    }), $.createElement(Eo, null, $.createElement(So, {
      id: "toggleImageLink",
      onChange: function onChange() {
        F(!I), I || (h(""), v(""));
      },
      type: "checkbox"
    }), $.createElement(zo, {
      htmlFor: "toggleImageLink",
      role: "switch"
    }, "Insert Link", $.createElement(Ao, {
      checked: I
    }, $.createElement("span", null)))), I && $.createElement($.Fragment, null, $.createElement(xo, null, "Link Title"), $.createElement(yo, {
      placeholder: "Enter Link Title",
      type: "text",
      value: m,
      onChange: function onChange(n) {
        return h(n.target.value);
      }
    }), $.createElement(xo, null, "Link URL"), $.createElement(yo, {
      placeholder: "Enter Link URL",
      type: "text",
      value: b,
      onChange: function onChange(n) {
        return v(n.target.value);
      }
    })), $.createElement(Co, null, $.createElement(Mo, {
      onClick: P
    }, "Cancel"), $.createElement(_o, {
      onClick: B
    }, "Save"))));
  }

  function wr(n, e) {
    return e ? n.createChecked(null, e) : n.createAndFill();
  }

  var xr,
      yr,
      Cr,
      _r,
      Mr,
      Er,
      zr,
      Ar,
      Sr,
      Tr,
      Lr,
      Ir,
      Fr,
      Dr,
      Br,
      Pr,
      Or,
      Rr,
      Nr,
      qr,
      $r,
      Hr,
      jr,
      Wr,
      Vr,
      Gr,
      Ur,
      Kr,
      Yr = g.css(xr = xr || E(["\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n  margin: 0;\n"], ["\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n  margin: 0;\n"])),
      Zr = t.h1(yr = yr || E(["\n  ", "\n"], ["\n  ", "\n"]), Yr),
      Qr = t.h2(Cr = Cr || E(["\n  ", "\n"], ["\n  ", "\n"]), Yr),
      Jr = t.h3(_r = _r || E(["\n  ", "\n"], ["\n  ", "\n"]), Yr),
      Xr = t.h4(Mr = Mr || E(["\n  ", "\n"], ["\n  ", "\n"]), Yr),
      no = t.h5(Er = Er || E(["\n  ", "\n"], ["\n  ", "\n"]), Yr),
      eo = t.h6(zr = zr || E(["\n  ", "\n"], ["\n  ", "\n"]), Yr),
      to = sr({
    Component: Zr,
    children: "Heading 1",
    command: ur(1),
    typeName: "heading",
    attrs: {
      level: 1
    }
  }),
      ro = sr({
    Component: Qr,
    children: "Heading 2",
    command: ur(2),
    typeName: "heading",
    attrs: {
      level: 2
    }
  }),
      oo = sr({
    Component: Jr,
    children: "Heading 3",
    command: ur(3),
    typeName: "heading",
    attrs: {
      level: 3
    }
  }),
      io = sr({
    Component: Xr,
    children: "Heading 4",
    command: ur(4),
    typeName: "heading",
    attrs: {
      level: 4
    }
  }),
      ao = sr({
    Component: no,
    children: "Heading 5",
    command: ur(5),
    typeName: "heading",
    attrs: {
      level: 5
    }
  }),
      so = sr({
    Component: eo,
    children: "Heading 6",
    command: ur(6),
    typeName: "heading",
    attrs: {
      level: 6
    }
  }),
      lo = t.span(Ar = Ar || E(["\n  display: flex;\n  left: 50%;\n  position: absolute;\n  top: -8px;\n  transform: translate3d(-50%, -100%, 0);\n  button:not(:first-of-type) {\n    margin-left: 10px;\n  }\n"], ["\n  display: flex;\n  left: 50%;\n  position: absolute;\n  top: -8px;\n  transform: translate3d(-50%, -100%, 0);\n  button:not(:first-of-type) {\n    margin-left: 10px;\n  }\n"])),
      co = t.span(Sr = Sr || E(["\n  position: absolute;\n  top: 50%;\n  left: -8px;\n  transform: translate3d(-100%, -50%, 0);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: -8px;\n  transform: translate3d(-100%, -50%, 0);\n"])),
      uo = t.div(Tr = Tr || E(["\n  top: -7px;\n  position: absolute;\n  right: 0;\n  padding: 8px;\n  transform: translate3d(50%, -100%, 0);\n  user-select: none;\n"], ["\n  top: -7px;\n  position: absolute;\n  right: 0;\n  padding: 8px;\n  transform: translate3d(50%, -100%, 0);\n  user-select: none;\n"])),
      po = t.div(Lr = Lr || E(["\n  background: #e1ddec;\n  border-radius: 50%;\n  height: 4px;\n  width: 4px;\n"], ["\n  background: #e1ddec;\n  border-radius: 50%;\n  height: 4px;\n  width: 4px;\n"])),
      fo = t.span(Ir = Ir || E(["\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n"], ["\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n"])),
      mo = t.div(Fr = Fr || E(["\n  position: absolute;\n  background: #0574e4;\n  top: ", "px;\n  z-index: 1000;\n  right: ", "px;\n  width: ", "px;\n  height: ", ";\n"], ["\n  position: absolute;\n  background: #0574e4;\n  top: ", "px;\n  z-index: 1000;\n  right: ", "px;\n  width: ", "px;\n  height: ", ";\n"]), -1, -1, 2, function (n) {
    return n.height + 12 - 1 + "px";
  }),
      ho = t.div(Dr = Dr || E(["\n  left: -7px;\n  position: absolute;\n  bottom: 0;\n  padding: 8px;\n  transform: translate3d(-100%, 50%, 0);\n  user-select: none;\n"], ["\n  left: -7px;\n  position: absolute;\n  bottom: 0;\n  padding: 8px;\n  transform: translate3d(-100%, 50%, 0);\n  user-select: none;\n"])),
      go = t.div(Br = Br || E(["\n  background: #e1ddec;\n  border-radius: 50%;\n  height: 4px;\n  width: 4px;\n"], ["\n  background: #e1ddec;\n  border-radius: 50%;\n  height: 4px;\n  width: 4px;\n"])),
      bo = t.span(Pr = Pr || E(["\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translate3d(-50%, -50%, 0);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translate3d(-50%, -50%, 0);\n"])),
      vo = t.div(Or = Or || E(["\n  position: absolute;\n  background: #0574e4;\n  left: ", "px;\n  z-index: 1000;\n  bottom: ", "px;\n  height: ", "px;\n  width: ", ";\n"], ["\n  position: absolute;\n  background: #0574e4;\n  left: ", "px;\n  z-index: 1000;\n  bottom: ", "px;\n  height: ", "px;\n  width: ", ";\n"]), -1, -1, 2, function (n) {
    return n.width + 12 - 1 + "px";
  }),
      ko = t.div(Rr = Rr || E(["\n  background-color: #ffffff;\n  border-radius: 2px;\n  cursor: default;\n  padding: 0px 4px;\n  position: absolute;\n  top: ", ";\n  left: ", ";\n"], ["\n  background-color: #ffffff;\n  border-radius: 2px;\n  cursor: default;\n  padding: 0px 4px;\n  position: absolute;\n  top: ", ";\n  left: ", ";\n"]), function (n) {
    return n.height + 24 + "px";
  }, function (n) {
    return n.width / 2 - 8 + "px";
  }),
      wo = t.span(Nr = Nr || E(["\n  background-color: #f6f6f9;\n  position: absolute;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  filter: drop-shadow(0px 4px 8px rgba(48, 48, 48, 0.1))\n    drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.12));\n  transform-origin: 50% 0;\n  overflow: visible;\n  padding: 12px;\n  z-index: 10;\n  width: 16rem;\n  left: ", ";\n  top: ", ";\n"], ["\n  background-color: #f6f6f9;\n  position: absolute;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  filter: drop-shadow(0px 4px 8px rgba(48, 48, 48, 0.1))\n    drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.12));\n  transform-origin: 50% 0;\n  overflow: visible;\n  padding: 12px;\n  z-index: 10;\n  width: 16rem;\n  left: ", ";\n  top: ", ";\n"]), O.radius("small"), O.color.grey(2), function (n) {
    return n.left + "px";
  }, function (n) {
    return n.top + "px";
  }),
      xo = t.label(qr = qr || E(["\n  display: block;\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: ", ";\n  margin-bottom: 3px;\n"], ["\n  display: block;\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: ", ";\n  margin-bottom: 3px;\n"]), O.font.size(1), O.color.grey(8)),
      yo = t.input($r = $r || E(["\n  position: relative;\n  background-color: white;\n  border-radius: ", ";\n  font-size: ", ";\n  line-height: 1.35;\n  transition: all 85ms ease-out;\n  padding: 8px 12px;\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0 0 8px 0;\n  outline: none;\n  box-shadow: 0 0 0 2px transparent;\n\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px #0084ff;\n  }\n\n  &::placeholder {\n    font-size: ", ";\n    color: #cfd3d7;\n  }\n"], ["\n  position: relative;\n  background-color: white;\n  border-radius: ", ";\n  font-size: ", ";\n  line-height: 1.35;\n  transition: all 85ms ease-out;\n  padding: 8px 12px;\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0 0 8px 0;\n  outline: none;\n  box-shadow: 0 0 0 2px transparent;\n\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px #0084ff;\n  }\n\n  &::placeholder {\n    font-size: ", ";\n    color: #cfd3d7;\n  }\n"]), O.radius("small"), O.font.size(1), O.color.grey(2), O.color.grey(3), O.font.size(2)),
      Co = t.div(Hr = Hr || E(["\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 4px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 4px;\n"])),
      _o = t.button(jr = jr || E(["\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  background-color: #0084ff;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 85ms ease-out;\n  font-size: ", ";\n  padding: 8px 20px;\n  margin-left: 8px;\n  &:hover {\n    background-color: #2296fe;\n  }\n  &:active {\n    background-color: #0574e4;\n  }\n"], ["\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  background-color: #0084ff;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 85ms ease-out;\n  font-size: ", ";\n  padding: 8px 20px;\n  margin-left: 8px;\n  &:hover {\n    background-color: #2296fe;\n  }\n  &:active {\n    background-color: #0574e4;\n  }\n"]), O.radius(), O.font.size(0)),
      Mo = t(_o)(Wr = Wr || E(["\n  background-color: white;\n  border: 1px solid ", ";\n  color: #0084ff;\n  &:hover {\n    background-color: #f6f6f9;\n    opacity: 1;\n  }\n"], ["\n  background-color: white;\n  border: 1px solid ", ";\n  color: #0084ff;\n  &:hover {\n    background-color: #f6f6f9;\n    opacity: 1;\n  }\n"]), O.color.grey(2)),
      Eo = t.div(Vr = Vr || E(["\n  display: block;\n  position: relative;\n  margin: 0 0 0.5rem 0;\n"], ["\n  display: block;\n  position: relative;\n  margin: 0 0 0.5rem 0;\n"])),
      zo = t.label(Gr = Gr || E(["\n  background: none;\n  color: inherit;\n  padding: 0;\n  opacity: ", ";\n  outline: none;\n  height: 28px;\n  pointer-events: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  color: ", ";\n"], ["\n  background: none;\n  color: inherit;\n  padding: 0;\n  opacity: ", ";\n  outline: none;\n  height: 28px;\n  pointer-events: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  color: ", ";\n"]), function (n) {
    return n.disabled ? "0.4" : "1";
  }, function (n) {
    return n.disabled ? "none" : "inherit";
  }, O.font.size(1), O.color.grey(8)),
      Ao = t.div(Ur = Ur || E(["\n  position: relative;\n  width: 48px;\n  height: 28px;\n  border-radius: ", ";\n  background-color: white;\n  border: 1px solid ", ";\n  pointer-events: none;\n  margin-left: -2px;\n  span {\n    position: absolute;\n    border-radius: ", ";\n    left: 2px;\n    top: 50%;\n    width: calc(28px - 6px);\n    height: calc(28px - 6px);\n    background: ", ";\n    transform: translate3d(", ", -50%, 0);\n    transition: all 150ms ease-out;\n  }\n"], ["\n  position: relative;\n  width: 48px;\n  height: 28px;\n  border-radius: ", ";\n  background-color: white;\n  border: 1px solid ", ";\n  pointer-events: none;\n  margin-left: -2px;\n  span {\n    position: absolute;\n    border-radius: ", ";\n    left: 2px;\n    top: 50%;\n    width: calc(28px - 6px);\n    height: calc(28px - 6px);\n    background: ", ";\n    transform: translate3d(", ", -50%, 0);\n    transition: all 150ms ease-out;\n  }\n"]), O.radius(), O.color.grey(2), O.radius(), function (n) {
    return n.checked ? O.color.primary() : O.color.grey(3);
  }, function (n) {
    return n.checked ? "20px" : "0";
  }),
      So = t.input(Kr = Kr || E(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 48px;\n  height: 28px;\n  opacity: 0;\n  margin: 0;\n  cursor: ", ";\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 48px;\n  height: 28px;\n  opacity: 0;\n  margin: 0;\n  cursor: ", ";\n"]), function (n) {
    return n.disabled ? "not-allowed" : "pointer";
  }),
      To = R.createContext(function () {
    return null;
  });

  function Lo(n) {
    var e = n.children,
        t = R.useRef(null),
        r = R.useCallback(function (n) {
      return t.current ? w.createPortal(n.children, t.current) : null;
    }, [t.current]);
    return R.createElement(To.Provider, {
      value: r
    }, R.createElement(Bo, {
      ref: t
    }, e));
  }

  function Io(n) {
    var e = n.view,
        t = n.bottom,
        r = void 0 !== t && t,
        o = n.theme,
        i = n.sticky,
        a = void 0 === i || i,
        s = R.useState(!1),
        l = s[0],
        c = s[1],
        d = "undefined" != typeof window,
        u = R.useRef(null),
        p = R.useState(null),
        f = p[0],
        m = p[1];
    R.useEffect(function () {
      u.current && a && m(u.current.getBoundingClientRect());
    }, [u]), R.useLayoutEffect(function () {
      if (d && u.current && a) {
        var n = function n() {
          var n = u.current.parentElement,
              e = n ? n.offsetTop : 0,
              t = n ? e + n.offsetHeight : 0;
          window.scrollY > e && window.scrollY < t ? c(!0) : c(!1);
        },
            e = function e() {
          if (u.current) {
            var n = l;
            c(!1), m(u.current.getBoundingClientRect()), c(n);
          }
        };

        return window.addEventListener("scroll", n), window.addEventListener("resize", e), function () {
          window.removeEventListener("scroll", n), window.removeEventListener("resize", e);
        };
      }
    }, [u, f]);
    var h = R.useCallback(function (n) {
      n.stopPropagation(), n.preventDefault();
    }, []);
    return R.createElement(g.ThemeProvider, {
      theme: o
    }, R.createElement(R.Fragment, null, l && R.createElement(li, {
      menuBoundingBox: f
    }), R.createElement(ci, {
      menuFixed: l,
      menuBoundingBox: f,
      ref: u
    }, R.createElement(Lo, null, R.createElement(di, {
      onMouseDown: h
    }, R.createElement(cr, {
      view: e
    }), R.createElement(Po, {
      view: e
    }), R.createElement(Oo, {
      view: e
    }), R.createElement(Ro, {
      view: e
    }), R.createElement(No, {
      view: e
    }), R.createElement(ri, {
      view: e,
      bottom: r
    }), R.createElement(oi, {
      view: e,
      bottom: r
    }), R.createElement(ii, {
      view: e,
      bottom: r
    }), R.createElement(ai, {
      view: e,
      bottom: r
    }), R.createElement(si, {
      view: e,
      bottom: r
    })))), R.createElement(vr, {
      view: e
    }), R.createElement(kr, {
      view: e
    })));
  }

  function Fo(t, n, e, r, o) {
    return void 0 === o && (o = !0), C(i, a = R.Component), i.prototype.render = function () {
      return R.createElement(pi, {
        "data-tooltip": r,
        onClick: this.onClick,
        bottom: this.props.bottom,
        disabled: !this.canDo()
      }, R.createElement(n, null));
    }, i;

    function i() {
      var e = null !== a && a.apply(this, arguments) || this;
      return e.onClick = function () {
        if (e.canDo()) {
          var n = e.props.view;
          t(n.state, n.dispatch), o && n.focus();
        }
      }, e.canDo = function () {
        return t(e.props.view.state);
      }, e;
    }

    var a;
  }

  var Do,
      Bo = t.div(Do = Do || E([""], [""])),
      Po = ar({
    mark: "strong",
    Icon: m.BoldIcon,
    tooltip: "Bold"
  }),
      Oo = ar({
    mark: "em",
    Icon: m.ItalicIcon,
    tooltip: "Italic"
  }),
      Ro = ar({
    mark: "underline",
    Icon: m.UnderlineIcon,
    tooltip: "Underline"
  }),
      No = ar({
    mark: "link",
    Icon: m.LinkIcon,
    tooltip: "Link",
    selectionOnly: !0,
    defaultAttrs: {
      href: "",
      title: "",
      editing: "editing",
      creating: "creating"
    },
    noMix: ["code"],
    isDisabled: function isDisabled(n) {
      return !!_e.getState(n.state).selectedImage;
    }
  });

  function qo(n) {
    var e = n.view,
        t = n.translator,
        r = n.bottom,
        o = n.theme,
        i = n.sticky;
    return R.createElement(bi.Provider, {
      value: t
    }, R.createElement(Io, {
      view: e,
      bottom: r,
      format: "markdown",
      theme: o,
      sticky: i
    }));
  }

  var $o,
      Ho,
      jo,
      Wo,
      Vo,
      Go,
      Uo,
      Ko,
      Yo,
      Zo,
      Qo,
      Jo,
      Xo,
      ni,
      ei,
      ti,
      ri = Fo(function (n, e) {
    var t = n.schema.nodes.table,
        r = n.selection;
    return !x.findParentNodeOfType(t)(r) && function (n, e) {
      if (!e) return !0;

      for (var t = n.schema.nodes, r = t.table_cell, o = t.table_header, i = t.table_row, a = t.table, s = [], l = [], c = 0; c < 3; c += 1) {
        l.push(wr(o)), s.push(wr(r));
      }

      var d = [];

      for (c = 0; c < 3; c += 1) {
        d.push(i.createChecked(null, 0 === c ? l : s));
      }

      var u = a.createChecked(null, d),
          p = n.selection,
          f = n.tr,
          m = p.$from,
          h = p.$to;
      return e(f.replaceWith(m.pos, h.pos, u).scrollIntoView()), !0;
    }(n, e);
  }, m.TableIcon, 0, "Table"),
      oi = Fo(function (n, e) {
    var t = n.schema.nodes.blockquote,
        r = x.findParentNodeOfType(t)(n.selection) || {},
        o = r.start,
        i = r.node;

    if (o && i) {
      var a = n.tr,
          s = a.doc.resolve(o + 1).blockRange(a.doc.resolve(o + i.nodeSize - 2));
      if (s) return !e || e(a.lift(s, 0));
    }

    return v.wrapIn(n.schema.nodes.blockquote)(n, e);
  }, m.QuoteIcon, 0, "Blockquote"),
      ii = Fo(function (n, e) {
    return v.setBlockType(n.schema.nodes.code_block)(n, e);
  }, m.CodeIcon, 0, "Codeblock", !1),
      ai = Fo(Wt, m.UnorderedListIcon, 0, "Unordered List"),
      si = Fo(Vt, m.OrderedListIcon, 0, "Ordered List"),
      li = t.div($o = $o || E(["\n  color: transparent;\n  background: transparent;\n  pointer-events: none;\n  position: relative;\n  display: block;\n  height: ", "px;\n  width: ", "px;\n"], ["\n  color: transparent;\n  background: transparent;\n  pointer-events: none;\n  position: relative;\n  display: block;\n  height: ", "px;\n  width: ", "px;\n"]), function (n) {
    return n.menuBoundingBox.height;
  }, function (n) {
    return n.menuBoundingBox.width;
  }),
      ci = t.div(jo = jo || E(["\n  position: relative;\n  margin-bottom: 14px;\n  z-index: 10000;\n\n  ", ";\n"], ["\n  position: relative;\n  margin-bottom: 14px;\n  z-index: 10000;\n\n  ", ";\n"]), function (n) {
    return n.menuFixed && g.css(Ho = Ho || E(["\n      position: fixed;\n      width: ", "px;\n      top: 0;\n    "], ["\n      position: fixed;\n      width: ", "px;\n      top: 0;\n    "]), n.menuBoundingBox.width);
  }),
      di = t.div(Wo = Wo || E(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  position: relative;\n  top: 0;\n  width: 100%;\n  background-color: white;\n  border-radius: ", ";\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  border: 1px solid ", ";\n  overflow: hidden;\n  z-index: 100;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  position: relative;\n  top: 0;\n  width: 100%;\n  background-color: white;\n  border-radius: ", ";\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  border: 1px solid ", ";\n  overflow: hidden;\n  z-index: 100;\n"]), O.radius(), O.color.grey(2)),
      ui = g.css(Vo = Vo || E(["\n  flex: 1 1 24px;\n"], ["\n  flex: 1 1 24px;\n"])),
      pi = t.button(Ko = Ko || E(["\n  ", "\n  background-color: ", ";\n  color: ", ";\n  fill: ", ";\n  border: 1px solid ", ";\n  margin: -1px;\n  outline: none;\n  padding: 6px 4px;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    background-color: rgba(53, 50, 50, 0.09);\n  }\n  &:active {\n    color: #0084ff;\n    fill: #0084ff;\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n  ", ";\n  ", ";\n"], ["\n  ", "\n  background-color: ", ";\n  color: ", ";\n  fill: ", ";\n  border: 1px solid ", ";\n  margin: -1px;\n  outline: none;\n  padding: 6px 4px;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    background-color: rgba(53, 50, 50, 0.09);\n  }\n  &:active {\n    color: #0084ff;\n    fill: #0084ff;\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n  ", ";\n  ", ";\n"]), ui, function (n) {
    return n.active ? "rgba(53, 50, 50, 0.05)" : "transparent";
  }, function (n) {
    return n.active ? "#0084ff" : O.color.grey(8);
  }, function (n) {
    return n.active ? "#0084ff" : O.color.grey(8);
  }, O.color.grey(2), function (n) {
    return n.active && g.css(Go = Go || E(["\n      color: #0084ff;\n      fill: #0084ff;\n      background-color: rgba(53, 50, 50, 0.05);\n    "], ["\n      color: #0084ff;\n      fill: #0084ff;\n      background-color: rgba(53, 50, 50, 0.05);\n    "]));
  }, function (n) {
    return n.disabled && g.css(Uo = Uo || E(["\n      pointer-events: none;\n      color: #d1d1d1;\n      fill: #d1d1d1;\n    "], ["\n      pointer-events: none;\n      color: #d1d1d1;\n      fill: #d1d1d1;\n    "]));
  }),
      fi = t.div(Yo = Yo || E(["\n  ", "\n  position: relative;\n\n  ", " {\n    width: 100%;\n  }\n"], ["\n  ", "\n  position: relative;\n\n  ", " {\n    width: 100%;\n  }\n"]), ui, pi),
      mi = t(function (n) {
    var e = n.children,
        t = (n.open, n.triggerRef),
        r = _(n, ["children", "open", "triggerRef"]),
        o = R.useContext(To),
        i = R.useRef(null),
        a = R.useMemo(function () {
      if (!t.current || !i.current) return 0;
      var n = t.current.getBoundingClientRect(),
          e = i.current.getBoundingClientRect();
      return n.x - e.x;
    }, [t.current, i.current]);

    return R.createElement(o, null, R.createElement(hi, {
      offset: a
    }, R.createElement("div", _H({
      ref: i
    }, r), e)));
  })(Qo = Qo || E(["\n  border-radius: ", ";\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  transform: translate3d(0, 100%, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 85ms ease-out;\n  transform-origin: 0 0;\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(48, 48, 48, 0.1);\n  background-color: white;\n  overflow: hidden;\n\n  ", ";\n"], ["\n  border-radius: ", ";\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  transform: translate3d(0, 100%, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 85ms ease-out;\n  transform-origin: 0 0;\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(48, 48, 48, 0.1);\n  background-color: white;\n  overflow: hidden;\n\n  ", ";\n"]), O.radius(), function (n) {
    return n.open && g.css(Zo = Zo || E(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 100%, 0) scale3d(1, 1, 1);\n    "], ["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 100%, 0) scale3d(1, 1, 1);\n    "]));
  }),
      hi = t.div(Jo = Jo || E(["\n  position: absolute;\n  left: ", "px;\n"], ["\n  position: absolute;\n  left: ", "px;\n"]), function (n) {
    return n.offset;
  }),
      gi = t.div(ni = ni || E(["\n  display: block;\n  padding: 8px 16px;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  &:first-child {\n    padding-top: ", ";\n  }\n  &:last-child {\n    padding-bottom: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n    fill: ", ";\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n  ", ";\n"], ["\n  display: block;\n  padding: 8px 16px;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  &:first-child {\n    padding-top: ", ";\n  }\n  &:last-child {\n    padding-bottom: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n    fill: ", ";\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n  ", ";\n"]), O.padding("small"), O.padding("small"), O.color.grey(1), O.color.primary(), O.color.primary(), O.color.primary(), function (n) {
    return n.active && g.css(Xo = Xo || E(["\n      color: #0084ff;\n      fill: #0084ff;\n      background-color: rgba(53, 50, 50, 0.05);\n    "], ["\n      color: #0084ff;\n      fill: #0084ff;\n      background-color: rgba(53, 50, 50, 0.05);\n    "]));
  }),
      bi = R.createContext(null),
      vi = t(function (n) {
    var e = n.input,
        t = (n.plugins, n.sticky),
        r = n.format,
        o = _(n, ["input", "plugins", "sticky", "format"]),
        i = R.useContext(g.ThemeContext) || {},
        a = wt(e, rr, i, r),
        s = a.elRef,
        l = a.editorView,
        c = a.translator;

    return R.createElement(ki, null, R.createElement("link", {
      rel: "stylesheet",
      href: "https://codemirror.net/lib/codemirror.css"
    }), l && R.createElement(qo, {
      view: l,
      bottom: !1,
      translator: c,
      theme: i,
      sticky: t
    }), R.createElement("div", _H({}, o, {
      ref: s
    })));
  })(ei = ei || E(["\n  ", "", "\n"], ["\n  ", "", "\n"]), or, ir),
      ki = t.div(ti = ti || E(["\n  position: relative;\n"], ["\n  position: relative;\n"]));
  n.ColorPicker = function (n) {
    var e = n.colorFormat,
        t = n.userColors,
        r = void 0 === t ? fn : t,
        o = n.widget,
        i = void 0 === o ? "sketch" : o,
        a = n.input,
        s = mn[i];
    if (!s) throw new Error("You must specify a widget type.");
    var l = R.useState(!1),
        c = l[0],
        d = l[1],
        u = (e || F.Hex).toLowerCase(),
        p = a.value ? sn[u].parse(a.value) : null;
    return R.createElement(R.Fragment, null, R.createElement(ln, {
      onClick: function onClick() {
        return d(!c);
      },
      colorRGBA: p,
      colorFormat: u
    }), c && R.createElement(dn, null, R.createElement(f.Dismissible, {
      click: !0,
      escape: !0,
      disabled: !c,
      onDismiss: function onDismiss() {
        return d(!1);
      }
    }, R.createElement(s, {
      presetColors: M(r, [pn]),
      color: p || {
        r: 0,
        g: 0,
        b: 0,
        a: 0
      },
      onChange: function onChange(n) {
        var e = n.hex === pn ? null : _H(_H({}, n.rgb), {
          a: 1
        });
        a.onChange(e ? sn[u].getValue(e) : null);
      },
      disableAlpha: !0,
      width: "240px"
    }))));
  }, n.Cover = un, n.ImageUpload = function (n) {
    var e = n.onDrop,
        t = n.onClear,
        r = n.value,
        o = n.previewSrc,
        i = u.useDropzone({
      accept: "image/*",
      onDrop: e
    }),
        a = i.getRootProps,
        s = i.getInputProps,
        l = i.isDragActive,
        c = i.isDragAccept,
        d = i.isDragReject;
    return R.createElement(wn, _H({}, a({
      isDragActive: l,
      isDragAccept: c,
      isDragReject: d
    })), R.createElement("input", _H({}, s())), r ? R.createElement(_n, null, R.createElement(yn, {
      src: o
    }), t && R.createElement(Cn, {
      onClick: function onClick(n) {
        n.stopPropagation(), t();
      }
    }, R.createElement(m.TrashIcon, null))) : R.createElement(xn, null, "Drag 'n' drop some files here,", R.createElement("br", null), "or click to select files"));
  }, n.Input = P, n.InputCss = B, n.NumberInput = function (n) {
    var e = n.onChange,
        t = n.value,
        r = n.step;
    return R.createElement(P, {
      type: "number",
      step: r,
      value: t,
      onChange: e
    });
  }, n.Popover = dn, n.Select = function (n) {
    var e = n.input,
        t = n.field,
        r = n.options || t.options;
    return R.createElement(kn, null, R.createElement("select", _H({
      id: e.name,
      value: e.value,
      onChange: e.onChange
    }, e), r ? r.map(function (n) {
      return R.createElement("option", {
        value: n,
        key: n
      }, n);
    }) : R.createElement("option", null, e.value)));
  }, n.Swatch = ln, n.TextArea = W, n.TextField = j, n.Toggle = function (n) {
    var e = !(!n.input.value && !n.input.checked);
    return R.createElement(hn, null, R.createElement(vn, _H({
      id: n.name,
      type: "checkbox"
    }, n.input)), R.createElement(gn, {
      htmlFor: n.name,
      role: "switch",
      disabled: n.disabled
    }, R.createElement(bn, {
      checked: e
    }, R.createElement("span", null))));
  }, n.Wysiwyg = vi, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});